import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function TechStore() {
  const [categories] = useState({
    
      "Mobiles": [

    
        
  { "name": "Apple iPhone 16 Pro", "price": 112900 },
  { "name": "Samsung Galaxy S25+", "price": 89990 },
  { "name": "Xiaomi Redmi Note 13 Pro", "price": 21999 },
  { "name": "Realme 12 Pro+", "price": 28999 },
  { "name": "vivo Y100 5G", "price": 17999 },
  { "name": "OPPO A78", "price": 16999 },
  { "name": "OnePlus Nord CE 5", "price": 24999 },
  { "name": "Motorola Edge 60 Fusion", "price": 22999 },
  { "name": "Infinix Zero 5G 2023", "price": 15999 },
  { "name": "Tecno Spark 20 Pro", "price": 13999 },
  { "name": "Lava Storm 5G", "price": 12999 },
  { "name": "iQOO Z7 5G", "price": 14999 },
  { "name": "Honor 90", "price": 37999 },
  { "name": "POCO M6 Pro", "price": 10999 },
  { "name": "Redmi 13C", "price": 8999 },
  { "name": "Samsung Galaxy A15", "price": 13999 },
  { "name": "Realme C67", "price": 11999 },
  { "name": "Motorola G73", "price": 16999 },
  { "name": "OPPO A59", "price": 14999 },
  { "name": "Vivo Y17s", "price": 10999 },
  { "name": "OnePlus Ace 3", "price": 34999 },
  { "name": "Samsung Galaxy F04", "price": 7499 },
  { "name": "Infinix Smart 7 HD", "price": 6499 },
  { "name": "Lava Yuva 3", "price": 7999 },
  { "name": "Itel A70", "price": 6999 },
  { "name": "Micromax IN 1", "price": 8999 },
  { "name": "Nokia G21", "price": 10499 },
  { "name": "JioPhone Next", "price": 4999 },
  { "name": "Samsung Galaxy Z Fold4", "price": 144999 },
  { "name": "Samsung Galaxy Z Flip4", "price": 84999 },
  { "name": "Motorola Razr 2023", "price": 79999 },
  { "name": "OnePlus 11R", "price": 39999 },
  { "name": "OPPO Find N2", "price": 99999 },
  { "name": "Asus Zenfone 9", "price": 59999 },
  { "name": "Sony Xperia 1 V", "price": 94999 },
  { "name": "Google Pixel 8", "price": 75999 },
  { "name": "Fairphone 3+", "price": 34999 },
  { "name": "Ulefone Armor X12", "price": 14999 },
  { "name": "Doogee S98", "price": 29999 },
  { "name": "Blackview BV7100", "price": 19999 },
  { "name": "Kyocera DuraXV Extreme", "price": 59999 },
  { "name": "Thuraya SatSleeve+", "price": 79999 },
  { "name": "CMF Phone 2", "price": 18999 },
  { "name": "Nothing Phone (3)", "price": 39999 },
  { "name": "Lenovo Legion Y90", "price": 69999 },
  { "name": "Razer Edge 5G", "price": 84999 },
  { "name": "RedMagic 8S Pro", "price": 64999 },
  { "name": "ASUS ROG Phone 6", "price": 89999 },
  { "name": "Samsung Galaxy F23", "price": 14999 },



  { "name": "Apple iPhone SE (2025)", "price": 49999 },
  { "name": "Samsung Galaxy A05s", "price": 10499 },
  { "name": "Xiaomi Redmi 12", "price": 11999 },
  { "name": "Realme C53", "price": 10999 },
  { "name": "vivo Y27", "price": 12999 },
  { "name": "OPPO A17", "price": 9999 },
  { "name": "OnePlus Nord N300", "price": 14999 },
  { "name": "Motorola G13", "price": 9999 },
  { "name": "Infinix Hot 30i", "price": 8499 },
  { "name": "Tecno Pop 7 Pro", "price": 7499 },
  { "name": "Lava Z6", "price": 8999 },
  { "name": "iQOO Z6 Lite", "price": 13999 },
  { "name": "Honor X8a", "price": 17999 },
  { "name": "POCO C55", "price": 8499 },
  { "name": "Redmi A2+", "price": 6999 },
  { "name": "Samsung Galaxy M04", "price": 8499 },
  { "name": "Realme Narzo N53", "price": 10999 },
  { "name": "Motorola E13", "price": 7499 },
  { "name": "OPPO A16e", "price": 7999 },
  { "name": "Vivo Y02", "price": 6999 },
  { "name": "OnePlus Nord N20 SE", "price": 13999 },
  { "name": "Samsung Galaxy A04", "price": 9999 },
  { "name": "Infinix Smart 6 HD", "price": 6499 },
  { "name": "Lava Z2 Max", "price": 7999 },
  { "name": "Itel Vision 3", "price": 6999 },
  { "name": "Micromax Bharat 2 Plus", "price": 3499 },
  { "name": "Nokia 110 4G", "price": 2499 },
  { "name": "Jio Bharat K1 Karbonn", "price": 999 },
  { "name": "Samsung Galaxy Z Fold3", "price": 139999 },
  { "name": "Samsung Galaxy Z Flip3", "price": 74999 },
  { "name": "Motorola Razr 5G", "price": 69999 },
  { "name": "OnePlus 10 Pro", "price": 61999 },
  { "name": "OPPO Find X5 Pro", "price": 89999 },
  { "name": "Asus Zenfone 8", "price": 49999 },
  { "name": "Sony Xperia Pro-I", "price": 129999 },
  { "name": "Google Pixel 7 Pro", "price": 84999 },
  { "name": "Fairphone 2", "price": 29999 },
  { "name": "Ulefone Armor 11T", "price": 34999 },
  { "name": "Doogee S96 GT", "price": 27999 },
  { "name": "Blackview BV6600", "price": 18999 },
  { "name": "Kyocera DuraForce Pro 2", "price": 49999 },
  { "name": "Thuraya XT-PRO Dual", "price": 109999 },
  { "name": "CMF Phone 3", "price": 20999 },
  { "name": "Nothing Phone (1)", "price": 29999 },
  { "name": "Lenovo Legion Duel 2", "price": 69999 },
  { "name": "Razer Phone 2", "price": 59999 },
  { "name": "RedMagic 7", "price": 54999 },
  { "name": "ASUS ROG Phone 5", "price": 69999 },
  { "name": "Samsung Galaxy F13", "price": 11999 },


        
  { "name": "Samsung Galaxy S25", "price": 92999 },
  { "name": "Apple iPhone 16", "price": 119900 },
  { "name": "Xiaomi Redmi K80 Pro", "price": 39999 },
  { "name": "Realme GT Neo 6", "price": 28999 },
  { "name": "vivo V30", "price": 33999 },
  { "name": "OPPO Reno 11", "price": 31999 },
  { "name": "OnePlus Nord 4", "price": 29999 },
  { "name": "Motorola G85", "price": 18999 },
  { "name": "Infinix GT 20 Pro", "price": 24999 },
  { "name": "Tecno Camon 30 Premier", "price": 27999 },
  { "name": "Lava Agni 2", "price": 21999 },
  { "name": "iQOO Z9", "price": 19999 },
  { "name": "Honor X9b", "price": 25999 },
  { "name": "POCO X6 Pro", "price": 26999 },
  { "name": "Redmi Note 13", "price": 17999 },
  { "name": "Samsung Galaxy M55", "price": 24999 },
  { "name": "Realme Narzo 60x", "price": 12999 },
  { "name": "Motorola Edge 40 Neo", "price": 22999 },
  { "name": "OPPO A79", "price": 18999 },
  { "name": "Vivo Y200", "price": 21999 },
  { "name": "OnePlus Nord CE 4", "price": 24999 },
  { "name": "Samsung Galaxy A35", "price": 27999 },
  { "name": "Infinix Note 40 Pro", "price": 21999 },
  { "name": "Lava Blaze Curve 5G", "price": 17999 },
  { "name": "Itel P55", "price": 8999 },
  { "name": "Micromax IN Note 2", "price": 11999 },
  { "name": "Nokia G42", "price": 12999 },
  { "name": "JioPhone Prima", "price": 2599 },
  { "name": "Samsung Galaxy Z Fold5", "price": 154999 },
  { "name": "Samsung Galaxy Z Flip5", "price": 99999 },
  { "name": "Motorola Razr 40 Ultra", "price": 84999 },
  { "name": "OnePlus 11", "price": 56999 },
  { "name": "OPPO Find N2 Flip", "price": 89999 },
  { "name": "Asus Zenfone 10", "price": 69999 },
  { "name": "Sony Xperia 10 VI", "price": 49999 },
  { "name": "Google Pixel 8 Pro", "price": 106999 },
  { "name": "Fairphone 4", "price": 44999 },
  { "name": "Ulefone Armor 22", "price": 39999 },
  { "name": "Doogee S100 Pro", "price": 34999 },
  { "name": "Blackview BV8800", "price": 29999 },
  { "name": "Kyocera DuraSport 5G", "price": 59999 },
  { "name": "Thuraya X5-Touch", "price": 99999 },
  { "name": "CMF Phone 1", "price": 15999 },
  { "name": "Nothing Phone (2a)", "price": 23999 },
  { "name": "Lenovo Legion Duel 3", "price": 79999 },
  { "name": "Razer Phone 3", "price": 74999 },
  { "name": "RedMagic 9 Pro", "price": 69999 },
  { "name": "ASUS ROG Phone 7", "price": 94999 },
  { "name": "Samsung Galaxy F15", "price": 13999 },





  { "name": "Apple iPhone 16 Pro Max", "price": 134900 },
  { "name": "Samsung Galaxy S25 Ultra", "price": 117999 },
  { "name": "Xiaomi 15 Ultra", "price": 109999 },
  { "name": "Motorola Razr 60 Ultra", "price": 99998 },
  { "name": "vivo X200 Pro", "price": 87490 },
  { "name": "OPPO Find X8 Pro", "price": 92999 },
  { "name": "OnePlus 13", "price": 64999 },
  { "name": "Realme Narzo 70x", "price": 12999 },
  { "name": "Nokia 3310 (2025 Edition)", "price": 3499 },
  { "name": "CAT S62 Pro", "price": 45999 },
  { "name": "Samsung Galaxy S25 Edge", "price": 109999 },
  { "name": "vivo X200", "price": 65999 },
  { "name": "Google Pixel 9 Pro", "price": 99999 },
  { "name": "Sony Xperia 1 VI", "price": 84999 },
  { "name": "Asus ROG Phone 8", "price": 79999 },
  { "name": "Infinix Zero Ultra", "price": 24999 },
  { "name": "Tecno Phantom V Flip", "price": 49999 },
  { "name": "Lava Blaze 5G", "price": 11999 },
  { "name": "iQOO Neo 9 Pro", "price": 34999 },
  { "name": "Honor Magic6 Pro", "price": 79990 },
  { "name": "POCO F6 Pro", "price": 36999 },
  { "name": "Redmi Note 13 Pro+", "price": 31999 },
  { "name": "Samsung Galaxy A55", "price": 39999 },
  { "name": "Realme GT 6", "price": 39999 },
  { "name": "Motorola Edge 50 Pro", "price": 31999 },
  { "name": "OPPO Reno 11 Pro", "price": 39999 },
  { "name": "Vivo V30 Pro", "price": 41999 },
  { "name": "OnePlus Nord CE 3 Lite", "price": 19999 },
  { "name": "Samsung Galaxy M14", "price": 12999 },
  { "name": "Infinix Smart 8", "price": 7499 },
  { "name": "Lava O2", "price": 8999 },
  { "name": "Itel S24", "price": 8499 },
  { "name": "Micromax IN 2B", "price": 7999 },
  { "name": "Nokia C32", "price": 8999 },
  { "name": "Jio Bharat V2", "price": 999 },
  { "name": "Samsung Galaxy Z Fold6", "price": 159999 },
  { "name": "Samsung Galaxy Z Flip6", "price": 99999 },
  { "name": "Motorola Razr 40", "price": 59999 },
  { "name": "OnePlus Open", "price": 139999 },
  { "name": "OPPO Find N3 Flip", "price": 94999 },
  { "name": "Asus Zenfone 11 Ultra", "price": 79999 },
  { "name": "Sony Xperia 5 VI", "price": 69999 },
  { "name": "Google Pixel Fold", "price": 149999 },
  { "name": "Fairphone 5", "price": 59999 },
  { "name": "Ulefone Armor 23 Ultra", "price": 49999 },
  { "name": "Doogee V30T", "price": 34999 },
  { "name": "Blackview BV9300", "price": 29999 },
  { "name": "Kyocera DuraForce Ultra 5G", "price": 69999 },
  { "name": "Thuraya XT-LITE", "price": 89999 },


  { "name": "Lava Agni 3", "price": 16999 },
  { "name": "Infinix GT 20 Pro", "price": 19999 },
  { "name": "Realme Narzo 70 Pro", "price": 19495 },
  { "name": "Poco X6 Neo", "price": 17999 },
  { "name": "Samsung Galaxy M14 5G", "price": 13999 },
  { "name": "Motorola G73 5G", "price": 16999 },
  { "name": "Redmi 13C 5G", "price": 10999 },
  { "name": "Realme C67 5G", "price": 13999 },
  { "name": "iQOO Z6 Lite 5G", "price": 11999 },
  { "name": "Infinix Smart 8 Plus", "price": 6999 },
  { "name": "Tecno Spark 20", "price": 9499 },
  { "name": "Lava O2", "price": 8999 },
  { "name": "Infinix Zero 5G 2023", "price": 14999 },
  { "name": "Realme Narzo N55", "price": 10999 },
  { "name": "Samsung Galaxy A05s", "price": 9999 },
  { "name": "Motorola E13", "price": 7499 },
  { "name": "Redmi 12 5G", "price": 12999 },
  { "name": "Realme C53", "price": 9999 },
  { "name": "Poco M6 Pro 5G", "price": 10999 },
  { "name": "Infinix Hot 40i", "price": 8999 },
  { "name": "Lava Blaze 5G", "price": 11999 },
  { "name": "Realme Narzo N53", "price": 8999 },
  { "name": "Samsung Galaxy F04", "price": 7499 },
  { "name": "Motorola G14", "price": 8999 },
  { "name": "Redmi A3", "price": 6999 },
  { "name": "Realme C51", "price": 7999 },
  { "name": "Poco C65", "price": 7499 },
  { "name": "Infinix Smart 8", "price": 7499 },
  { "name": "Lava Yuva 3", "price": 6999 },
  { "name": "Realme Narzo N32", "price": 7999 },
  { "name": "Samsung Galaxy M04", "price": 7999 },
  { "name": "Motorola G32", "price": 10999 },
  { "name": "Redmi 12C", "price": 7999 },
  { "name": "Realme C33", "price": 7999 },
  { "name": "Poco C55", "price": 7999 },
  { "name": "Infinix Note 12i", "price": 9999 },
  { "name": "Lava Blaze NXT", "price": 8999 },
  { "name": "Realme Narzo 50i Prime", "price": 6999 },
  { "name": "Samsung Galaxy A03", "price": 7499 },
  { "name": "Motorola E32s", "price": 7999 },
  { "name": "Redmi 10A", "price": 7499 },
  { "name": "Realme C30", "price": 6499 },
  { "name": "Poco C50", "price": 6499 },
  { "name": "Infinix Smart 7", "price": 6999 },
  { "name": "Lava Z6", "price": 8999 },
  { "name": "Realme Narzo 50A", "price": 9499 },
  { "name": "Samsung Galaxy M13", "price": 9999 },
  { "name": "Motorola G22", "price": 9999 },
  { "name": "Redmi 10", "price": 9999 },
  { "name": "Realme C25Y", "price": 9999 },

  { "name": "BlackBerry Q10", "price": 15477 },
  { "name": "BlackBerry DTEK50", "price": 18975 },
  { "name": "BlackBerry Classic", "price": 18768 },
  { "name": "BlackBerry Curve 8530 (Reliance)", "price": 10990 },
  { "name": "BlackBerry Bold 9650 (Reliance)", "price": 16990 },
  { "name": "Reliance LYF Flame 8", "price": 4999 },
  { "name": "Reliance LYF Water 10", "price": 7999 },
  { "name": "Reliance LYF Wind 7", "price": 5999 },
  { "name": "Micromax IN 2B", "price": 7999 },
  { "name": "Micromax Bharat 5 Infinity", "price": 6999 },
  { "name": "Lava Z61 Pro", "price": 5999 },
  { "name": "Lava Yuva 2 Pro", "price": 7999 },
  { "name": "Karbonn Titanium S9 Plus", "price": 6999 },
  { "name": "Karbonn K9 Smart Eco", "price": 4999 },
  { "name": "Intex Aqua Lions T1 Lite", "price": 4999 },
  { "name": "Intex Indie 5", "price": 5999 },
  { "name": "Celkon Smart 4G", "price": 5999 },
  { "name": "Celkon Diamond U", "price": 6999 },
  { "name": "Spice F305", "price": 4999 },
  { "name": "Spice Stellar 360", "price": 3499 },
  { "name": "Maxx AX8 Race", "price": 3999 },
  { "name": "XOLO Era 5X", "price": 6999 },
  { "name": "XOLO ZX", "price": 9999 },
  { "name": "Gionee Max", "price": 5999 },
  { "name": "Gionee F8 Neo", "price": 6499 },
  { "name": "iBall Andi 5G Blink 4G", "price": 5999 },
  { "name": "iBall Cobalt Oomph 4.7D", "price": 6999 },
  { "name": "Swipe Elite Sense", "price": 6999 },
  { "name": "Swipe Konnect Star", "price": 4999 },
  { "name": "Panasonic Eluga I8", "price": 8499 },
  { "name": "Panasonic P101", "price": 5999 },
  { "name": "Philips Xenium X818", "price": 12999 },
  { "name": "Philips S309", "price": 4999 },
  { "name": "LYF Earth 2", "price": 8999 },
  { "name": "LYF Water 7", "price": 7999 },
  { "name": "Jio Bharat V2", "price": 999 },
  { "name": "JioPhone Next", "price": 4499 },
  { "name": "Ulefone Note 16 Pro", "price": 9999 },
  { "name": "Umidigi A13 Pro", "price": 8999 },
  { "name": "Doogee X98 Pro", "price": 9999 },
  { "name": "Cubot Note 30", "price": 9999 },
  { "name": "Fairphone 3+", "price": 19999 },
  { "name": "Blackview A85", "price": 9999 },
  { "name": "Lephone W7", "price": 4999 },
  { "name": "I Kall Z6", "price": 6999 },
  { "name": "I Kall K500", "price": 5999 },
  { "name": "Snexian Guru 216", "price": 1499 },
  { "name": "Snexian Bold 4G", "price": 2999 },
  { "name": "Detel D1+", "price": 999 },
  { "name": "Detel D1 Slim", "price": 1099 },
{ "name": "Apple iPhone 16 Pro", "price": 112900 },
  { "name": "Samsung Galaxy S25", "price": 74999 },
  { "name": "Xiaomi 14 Ultra", "price": 74999 },
  { "name": "Oppo Reno13 Pro", "price": 41999 },
  { "name": "Vivo X200 Pro", "price": 89920 },
  { "name": "OnePlus 13", "price": 79999 },
  { "name": "Realme GT Neo 6", "price": 34999 },
  { "name": "Motorola Edge 60 Fusion", "price": 22999 },
  { "name": "Google Pixel 9A", "price": 49999 },
  { "name": "Sony Xperia 1 VI", "price": 89999 },
  { "name": "Nokia XR21", "price": 47999 },
  { "name": "Huawei P60 Pro", "price": 79999 },
  { "name": "Honor Magic6 Pro", "price": 79999 },
  { "name": "Asus ROG Phone 8 Pro", "price": 94999 },
  { "name": "Lenovo Legion Y90", "price": 59999 },
  { "name": "LG Velvet", "price": 44999 },
  { "name": "Micromax IN 2C", "price": 6999 },
  { "name": "Lava Blaze Curve 5G", "price": 17999 },
  { "name": "Infinix Zero 30 5G", "price": 22999 },
  { "name": "Tecno Phantom V Flip", "price": 49999 },
  { "name": "Itel S23 Plus", "price": 8999 },
  { "name": "iQOO 13", "price": 59999 },
  { "name": "Nothing Phone (3a)", "price": 29430 },
  { "name": "BlackBerry Key2", "price": 44999 },
  { "name": "HTC U23 Pro", "price": 39999 },
  { "name": "ZTE Axon 50 Ultra", "price": 54999 },
  { "name": "Meizu 20 Pro", "price": 49999 },
  { "name": "Coolpad Cool 20 Pro", "price": 13999 },
  { "name": "Alcatel 3L", "price": 8999 },
  { "name": "BLU G91 Max", "price": 14999 },
  { "name": "Celkon Smart 4G", "price": 5999 },
  { "name": "Karbonn Titanium S9", "price": 7999 },
  { "name": "XOLO Era 5X", "price": 6999 },
  { "name": "LYF Earth 2", "price": 8999 },
  { "name": "Gionee Max Pro", "price": 6999 },
  { "name": "Panasonic Eluga I8", "price": 8499 },
  { "name": "Sharp Aquos R7", "price": 69999 },
  { "name": "Philips Xenium X818", "price": 12999 },
  { "name": "Fairphone 5", "price": 59999 },
  { "name": "Ulefone Armor 23 Ultra", "price": 34999 },
  { "name": "Umidigi Bison GT2", "price": 17999 },
  { "name": "Doogee V20", "price": 17999 },
  { "name": "Cubot P80", "price": 10999 },
  { "name": "TCL 40 NXTPAPER", "price": 15999 },
  { "name": "Poco F6 Pro", "price": 36999 },
  { "name": "CMF Phone 2 Pro", "price": 21999 },
  { "name": "Jio Bharat V2", "price": 999 },
  { "name": "Intex Aqua Lions T1", "price": 4999 },
  { "name": "Maxx AX8 Race", "price": 3999 },
  { "name": "Spice Stellar 360", "price": 3499 },
  { "name": "iQOO Z10x", "price": 13498 },
  { "name": "Samsung Galaxy M36", "price": 17499 },
  { "name": "Realme Narzo 80 Pro", "price": 18998 },
  { "name": "Vivo T4x 5G", "price": 14999 },
  { "name": "OPPO K13x 5G", "price": 14999 },
  { "name": "Moto G85", "price": 15999 },
  { "name": "CMF Phone 2 Pro", "price": 17858 },
  { "name": "Redmi A4", "price": 7999 },
  { "name": "Realme P3", "price": 15999 },
  { "name": "Infinix Note 50s 5G+", "price": 16299 },
  { "name": "POCO X7", "price": 16499 },
  { "name": "Tecno Pova Curve 5G", "price": 15999 },
  { "name": "Realme 14T", "price": 15690 },
  { "name": "Samsung Galaxy F16 5G", "price": 10749 },
  { "name": "OnePlus Nord CE4 Lite", "price": 17040 },
  { "name": "Motorola Edge 50 Fusion", "price": 18999 },
  { "name": "Samsung Galaxy A35 5G", "price": 19999 },
  { "name": "Infinix Zero 30 5G", "price": 17890 },
  { "name": "Redmi Note 14 5G", "price": 16999 },
  { "name": "Realme Narzo 70 Turbo", "price": 18831 },
  { "name": "Motorola G64 5G", "price": 17596 },
  { "name": "Samsung Galaxy M55s", "price": 16198 },
  { "name": "Infinix Note 40 5G", "price": 15999 },
  { "name": "OPPO K13", "price": 17999 },
  { "name": "Realme P3 Pro", "price": 19999 },
  { "name": "Lava Blaze Curve 5G", "price": 17999 },
  { "name": "Infinix Note 30 5G", "price": 15999 },
  { "name": "Realme 13+ 5G", "price": 15499 },
  { "name": "Motorola Edge 50 Neo", "price": 19999 },
  { "name": "Poco X7 5G", "price": 15999 },
  { "name": "HMD Fusion", "price": 18999 },
  { "name": "Samsung Galaxy F06 5G", "price": 8499 },
  { "name": "Vivo T4", "price": 17999 },
  { "name": "Redmi Note 14 (128GB)", "price": 17999 },
  { "name": "Redmi Note 14 (256GB)", "price": 19998 },
  { "name": "Infinix Note 40 Pro 5G", "price": 18999 },
  { "name": "Infinix Note 40 Pro Racing Edition", "price": 18999 },
  { "name": "Samsung Galaxy F55 5G", "price": 19379 },
  { "name": "OPPO Reno 12 5G", "price": 19999 },
  { "name": "Motorola G85 5G (Olive Green)", "price": 15999 },
  { "name": "Motorola G85 5G (Urban Grey)", "price": 15999 },
  { "name": "Motorola G85 5G (256GB)", "price": 17999 },
  { "name": "Samsung Galaxy F16 5G (Vibing Blue)", "price": 11999 },
  { "name": "Samsung Galaxy F16 5G (Glam Green)", "price": 10749 },
  { "name": "Realme P2 Pro 5G", "price": 18999 },
  { "name": "CMF Phone 2 Pro (Light Green)", "price": 18999 },
  { "name": "CMF Phone 2 Pro (White)", "price": 18999 },
  { "name": "Samsung Galaxy A35 5G (Awesome Navy)", "price": 19999 },
  { "name": "Samsung Galaxy A35 5G (Awesome Iceblue)", "price": 19999 },
  { "name": "Samsung Galaxy A35 5G (Awesome Lilac)", "price": 19999 },

        


            ],
          
        
              "Laptops/ Books": [
              
                  { "name": "Apple MacBook Air M3", "price": 114900 },
  { "name": "Apple MacBook Pro M3 Pro 14-inch", "price": 169900 },
  { "name": "Apple MacBook Pro M3 Max 16-inch", "price": 249900 },
  { "name": "Dell XPS 13 Plus", "price": 129999 },
  { "name": "Dell Inspiron 15 13th Gen i5", "price": 58990 },
  { "name": "Dell Vostro 14 Ryzen 5", "price": 47990 },
  { "name": "HP Spectre x360 14", "price": 119999 },
  { "name": "HP Pavilion Plus 14", "price": 74999 },
  { "name": "HP Victus Gaming Ryzen 5", "price": 58990 },
  { "name": "Lenovo Yoga Slim 7i", "price": 99999 },
  { "name": "Lenovo IdeaPad Slim 3", "price": 42990 },
  { "name": "Lenovo Legion 5 Pro", "price": 129990 },
  { "name": "Asus ROG Zephyrus G14", "price": 124999 },
  { "name": "Asus Vivobook Go 15", "price": 41990 },
  { "name": "Asus TUF Gaming F15", "price": 48990 },
  { "name": "Acer Swift Go OLED", "price": 84999 },
  { "name": "Acer Aspire 7 Ryzen 5", "price": 48990 },
  { "name": "Acer Nitro V Gaming", "price": 59990 },
  { "name": "MSI Prestige 14", "price": 89999 },
  { "name": "MSI Modern 15", "price": 38990 },
  { "name": "Samsung Galaxy Book4 Pro", "price": 109999 },
  { "name": "Samsung Galaxy Book3", "price": 69999 },
  { "name": "Infinix ZeroBook Ultra", "price": 49990 },
  { "name": "Infinix INBook Y1 Plus", "price": 29990 },
  { "name": "Avita Liber V14", "price": 27990 },
  { "name": "Avita Pura Ryzen 3", "price": 23990 },
  { "name": "Primebook 4G Android Laptop", "price": 14999 },
  { "name": "Wings Nuvobook S1", "price": 19999 },
  { "name": "Ultimus Neo Intel i3", "price": 22490 },
  { "name": "AXL VayuBook N4020", "price": 11990 },
  { "name": "Futopia Ultimus Elite i5", "price": 21490 },
  { "name": "Gigabyte G5 MF Gaming", "price": 68805 },
  { "name": "CHUWI GemiBook XPro", "price": 16990 },
  { "name": "Walker Student Laptop", "price": 12490 },
  { "name": "RDP ThinBook 1010", "price": 14999 },
  { "name": "iBall CompBook M500", "price": 13999 },
  { "name": "Micromax Ignite LPQ61", "price": 17999 },
  { "name": "Lava Helium 14", "price": 14999 },
  { "name": "Reliance JioBook 4G", "price": 15999 },
  { "name": "Reliance JioBook 11", "price": 16499 },
  { "name": "Zebronics Pro Series Z", "price": 29990 },
  { "name": "Thomson Neo 14", "price": 21990 },
  { "name": "IBall Excelance CompBook", "price": 12999 },
  { "name": "HCL ME Laptop 2025", "price": 18999 },
  { "name": "Sony VAIO E Series", "price": 34990 },
  { "name": "Toshiba Satellite C50", "price": 29990 },
  { "name": "Panasonic Toughbook CF-54", "price": 49990 },
  { "name": "LG Gram 14", "price": 99990 },
  { "name": "Microsoft Surface Laptop Go 3", "price": 79999 },



  { "name": "Apple MacBook Air M2 13-inch", "price": 89990 },
  { "name": "Apple MacBook Air M2 15-inch", "price": 104900 },
  { "name": "Apple MacBook Pro M2 Pro 14-inch", "price": 169900 },
  { "name": "Apple MacBook Pro M2 Max 16-inch", "price": 249900 },
  { "name": "Dell Latitude 7440", "price": 119990 },
  { "name": "Dell G15 Gaming Ryzen 7", "price": 79990 },
  { "name": "Dell Alienware x14 R2", "price": 159990 },
  { "name": "HP Envy x360 15", "price": 84990 },
  { "name": "HP Omen Transcend 14", "price": 139990 },
  { "name": "HP ZBook Firefly G10", "price": 119990 },
  { "name": "Lenovo ThinkPad X1 Carbon Gen 11", "price": 144990 },
  { "name": "Lenovo Legion Slim 7", "price": 124990 },
  { "name": "Lenovo LOQ Gaming Ryzen 5", "price": 69990 },
  { "name": "Asus Zenbook 14 OLED", "price": 84990 },
  { "name": "Asus ROG Strix G17", "price": 139990 },
  { "name": "Asus ExpertBook B5", "price": 79990 },
  { "name": "Acer Predator Helios Neo 16", "price": 119990 },
  { "name": "Acer Aspire Go 14", "price": 59999 },
  { "name": "Acer Chromebook Plus 514", "price": 39990 },
  { "name": "MSI Katana 15", "price": 89990 },
  { "name": "MSI Stealth 14 Studio", "price": 129990 },
  { "name": "Samsung Galaxy Book4 360", "price": 79990 },
  { "name": "Samsung Galaxy Book3 Ultra", "price": 139990 },
  { "name": "Infinix ZeroBook 13", "price": 44990 },
  { "name": "Infinix INBook X3 Slim", "price": 34990 },
  { "name": "Avita Magus Lite", "price": 17990 },
  { "name": "Avita Cosmos 2-in-1", "price": 19990 },
  { "name": "Primebook Wi-Fi Android Laptop", "price": 14999 },
  { "name": "Wings Nuvobook V1", "price": 18999 },
  { "name": "Ultimus Neo Intel i5", "price": 28990 },
  { "name": "AXL VayuBook i3 11th Gen", "price": 22990 },
  { "name": "Futopia Ultimus Elite i3", "price": 18990 },
  { "name": "Gigabyte Aorus 15 Gaming", "price": 99990 },
  { "name": "CHUWI CoreBook XPro", "price": 24990 },
  { "name": "Walker ProBook 14", "price": 14990 },
  { "name": "RDP ThinBook 1430", "price": 16990 },
  { "name": "iBall CompBook Merit G9", "price": 12990 },
  { "name": "Micromax Alpha LI351", "price": 19990 },
  { "name": "Lava Helium 12", "price": 13990 },
  { "name": "Reliance JioBook 2025", "price": 17999 },
  { "name": "Zebronics Zebbook Pro", "price": 24990 },
  { "name": "Thomson Neo 15", "price": 23990 },
  { "name": "IBall Excelance CompBook C8", "price": 13990 },
  { "name": "HCL ME Laptop X1", "price": 16990 },
  { "name": "Sony VAIO Z Series", "price": 99990 },
  { "name": "Toshiba Dynabook Tecra", "price": 79990 },
  { "name": "Panasonic Toughbook CF-33", "price": 119990 },
  { "name": "LG Ultra PC 16", "price": 84990 },
  { "name": "Microsoft Surface Laptop Studio 2", "price": 189990 },


  { "name": "Apple MacBook Air M4 13-inch", "price": 99900 },
  { "name": "Apple MacBook Air M4 15-inch", "price": 124900 },
  { "name": "Apple MacBook Pro M4 Pro 14-inch", "price": 199900 },
  { "name": "Apple MacBook Pro M4 Max 16-inch", "price": 349900 },
  { "name": "Dell Inspiron 15 3530 i5 13th Gen", "price": 52490 },
  { "name": "Dell Inspiron 15 3520 i5 12th Gen", "price": 48200 },
  { "name": "Dell Vostro 15 3535 Ryzen 3", "price": 32990 },
  { "name": "HP Pavilion x360 14", "price": 64990 },
  { "name": "HP EliteBook 840 G10", "price": 99990 },
  { "name": "HP Omen 16 Gaming", "price": 65999 },
  { "name": "Lenovo IdeaPad Slim 5", "price": 38999 },
  { "name": "Lenovo IdeaPad Gaming 3", "price": 59990 },
  { "name": "Lenovo ThinkBook 14 Gen 6", "price": 69990 },
  { "name": "Asus Vivobook 15 X1504ZA", "price": 37290 },
  { "name": "Asus Vivobook S16 OLED", "price": 82990 },
  { "name": "Asus Vivobook S14 Flip", "price": 63990 },
  { "name": "Acer Aspire 3 A324-45", "price": 20490 },
  { "name": "Acer Aspire 3 A324-53", "price": 27990 },
  { "name": "Acer Aspire 7 A715-79G", "price": 54990 },
  { "name": "MSI Titan 18 HX AI", "price": 499999 },
  { "name": "MSI Cyborg 15 AI", "price": 79990 },
  { "name": "Samsung Galaxy Book4 Edge 16", "price": 139990 },
  { "name": "Samsung Galaxy Book4 NP750XGJ", "price": 34990 },
  { "name": "Infinix Inbook Air Pro Plus", "price": 49990 },
  { "name": "Infinix INBook X2 Slim", "price": 29990 },
  { "name": "Avita Essential NE14A2INC", "price": 21990 },
  { "name": "Avita Liber NS14A8INF", "price": 28990 },
  { "name": "Primebook 2025 Android Laptop", "price": 15999 },
  { "name": "Wings Nuvobook S2", "price": 20999 },
  { "name": "Ultimus Neo Intel i7", "price": 34990 },
  { "name": "AXL VayuBook i7 12th Gen", "price": 29990 },
  { "name": "Futopia Ultimus Elite i7", "price": 31990 },
  { "name": "Gigabyte AERO 14 OLED", "price": 99990 },
  { "name": "CHUWI HeroBook Pro", "price": 18990 },
  { "name": "Walker StudentBook 2025", "price": 13990 },
  { "name": "RDP ThinBook 1110", "price": 15990 },
  { "name": "iBall CompBook Aer3", "price": 17990 },
  { "name": "Micromax Canvas Lapbook L1160", "price": 14990 },
  { "name": "Lava Helium 12 Pro", "price": 15990 },
  { "name": "Reliance JioBook LTE", "price": 16990 },
  { "name": "Zebronics Zebbook Plus", "price": 21990 },
  { "name": "Thomson Neo 14 Pro", "price": 22990 },
  { "name": "IBall Excelance CompBook C9", "price": 14990 },
  { "name": "HCL ME Laptop Z2", "price": 17990 },
  { "name": "Sony VAIO Fit 15E", "price": 39990 },
  { "name": "Toshiba Satellite L50", "price": 31990 },
  { "name": "Panasonic Toughbook CF-20", "price": 69990 },
  { "name": "LG Gram SuperSlim 15", "price": 109990 },
  { "name": "Microsoft Surface Pro 12", "price": 67990 },



  { "name": "Lenovo IdeaPad Slim 3 CB 14M868 Chromebook", "price": 17990 },
  { "name": "Asus Chromebook CM14", "price": 18990 },
  { "name": "HP Chromebook x360 14a", "price": 21990 },
  { "name": "Acer Chromebook 311", "price": 15990 },
  { "name": "Samsung Chromebook 4", "price": 18990 },
  { "name": "Dell Chromebook 3100", "price": 19990 },
  { "name": "Lenovo 100e Chromebook Gen 4", "price": 10499 },
  { "name": "Asus Chromebook Flip C214", "price": 22990 },
  { "name": "HP Chromebook 11a", "price": 17990 },
  { "name": "Acer Chromebook Spin 311", "price": 20990 },
  { "name": "Lenovo Flex 3 Chromebook", "price": 21990 },
  { "name": "Samsung Galaxy Chromebook Go", "price": 19990 },
  { "name": "Dell Latitude 3190 Education", "price": 22990 },
  { "name": "HP Stream 11 Pro G5", "price": 19990 },
  { "name": "Acer TravelMate B3", "price": 21990 },
  { "name": "Lenovo 300e Chromebook", "price": 20990 },
  { "name": "Asus BR1100FKA Education Laptop", "price": 22990 },
  { "name": "HP ProBook x360 11 G5 EE", "price": 23990 },
  { "name": "Samsung Galaxy Book Go", "price": 24990 },
  { "name": "Dell Latitude 3310 Education", "price": 25990 },
  { "name": "Lenovo IdeaPad 1 Intel Celeron", "price": 18990 },
  { "name": "Asus VivoBook E210", "price": 19990 },
  { "name": "HP 14s Intel Celeron", "price": 20990 },
  { "name": "Acer Aspire 3 Intel N4500", "price": 21990 },
  { "name": "Micromax Canvas Lapbook L1161", "price": 14990 },
  { "name": "Lava Helium 12 Lite", "price": 13990 },
  { "name": "iBall CompBook Premio v2.0", "price": 15990 },
  { "name": "RDP ThinBook 1010e", "price": 14990 },
  { "name": "Avita Essential NE14A2INC", "price": 17990 },
  { "name": "Primebook 4G Student Edition", "price": 14999 },
  { "name": "Wings Nuvobook Lite", "price": 16999 },
  { "name": "AXL VayuBook Student Edition", "price": 15990 },
  { "name": "Futopia Ultimus Basic", "price": 17990 },
  { "name": "CHUWI HeroBook Air", "price": 14990 },
  { "name": "Walker EduBook 2025", "price": 13990 },
  { "name": "IBall Excelance CompBook C10", "price": 12990 },
  { "name": "HCL ME EduBook", "price": 14990 },
  { "name": "Sony VAIO Kids Edition", "price": 19990 },
  { "name": "Toshiba Satellite Student Model", "price": 18990 },
  { "name": "Panasonic Toughbook Lite", "price": 24990 },
  { "name": "LG Gram Lite 13", "price": 29990 },
  { "name": "Microsoft Surface Go Kids Edition", "price": 34990 },
  { "name": "Datawind Ubislate EduTab", "price": 4999 },
  { "name": "Digiflip Pro StudentBook", "price": 6999 },
  { "name": "Karbonn SmartBook ST72", "price": 5999 },
  { "name": "Celkon EduTab CT111", "price": 5999 },
  { "name": "Maxx Student Laptop GenX", "price": 4999 },
  { "name": "Spice Stellar StudentPad", "price": 7999 },
  { "name": "I Kall StudentBook N9", "price": 4999 },


              ],
             "Desktop Computer system": [
                 { "name": "Apple Mac Mini M4 (16GB/256GB SSD)", "price": 57990 },
  { "name": "HP 24-cr0014in AIO (Ryzen 3/8GB/512GB SSD)", "price": 37990 },
  { "name": "Lenovo IdeaCentre 08IRH9 (Core i5/8GB/512GB SSD)", "price": 47490 },
  { "name": "Dell Inspiron 3030S (Core i5/8GB/512GB SSD)", "price": 39250 },
  { "name": "Asus AiO V440 (Core i5/16GB/512GB SSD)", "price": 57990 },
  { "name": "Acer Aspire C24 (Core i3/8GB/256GB SSD)", "price": 34990 },
  { "name": "MSI Pro DP21 (Core i3/8GB/512GB SSD)", "price": 31990 },
  { "name": "Samsung Galaxy AIO (Core i5/16GB/512GB SSD)", "price": 49990 },
  { "name": "Zebronics Office PC (Core i3/8GB/500GB HDD)", "price": 8990 },
  { "name": "Intex Desktop PC (Pentium/4GB/500GB HDD)", "price": 7490 },
  { "name": "iBall iTower 2000 (Core i5/8GB/1TB HDD)", "price": 22990 },
  { "name": "Micromax Alpha Desktop (Core i3/4GB/500GB HDD)", "price": 9990 },
  { "name": "Lava Magnum PC (Celeron/4GB/256GB SSD)", "price": 8490 },
  { "name": "Reliance Jio Desktop (ARM/2GB/32GB eMMC)", "price": 6990 },
  { "name": "CHUWI HeroBox Mini PC (Celeron/8GB/256GB SSD)", "price": 15990 },
  { "name": "Beelink Mini S12 Pro (Intel N100/16GB/500GB SSD)", "price": 18990 },
  { "name": "Primebook Desktop (Android/4GB/64GB)", "price": 9990 },
  { "name": "Wings Workstation W1 (Core i3/8GB/512GB SSD)", "price": 21990 },
  { "name": "AXL VayuBox (Intel N4020/4GB/128GB SSD)", "price": 11990 },
  { "name": "Futopia Basic PC (Core i3/8GB/1TB HDD)", "price": 19990 },
  { "name": "Gigabyte Brix Mini PC (Ryzen 5/8GB/256GB SSD)", "price": 28990 },
  { "name": "CHUWI CoreBox X (Core i5/16GB/512GB SSD)", "price": 34990 },
  { "name": "Walker Student PC (Celeron/4GB/128GB SSD)", "price": 9990 },
  { "name": "RDP Workstation 1010 (Core i3/8GB/1TB HDD)", "price": 14990 },
  { "name": "IBall iTower 3000 (Core i7/16GB/1TB SSD)", "price": 49990 },
  { "name": "HCL ME Desktop (Pentium/4GB/500GB HDD)", "price": 8990 },
  { "name": "Sony VAIO Desktop E Series (Core i5/8GB/1TB HDD)", "price": 34990 },
  { "name": "Toshiba Satellite PC (Core i3/4GB/500GB HDD)", "price": 29990 },
  { "name": "Panasonic ToughStation CF-54 (Core i5/8GB/256GB SSD)", "price": 49990 },
  { "name": "LG Ultra PC Desktop (Core i5/8GB/512GB SSD)", "price": 49990 },
  { "name": "Microsoft Surface Studio 3 (Core i7/32GB/1TB SSD)", "price": 189990 },
  { "name": "HP OmniStudio X 32-c1574in (Core Ultra 7/32GB/1TB SSD)", "price": 169990 },
  { "name": "Lenovo IdeaCentre AIO 27IRH9 (Core i7/32GB/1TB SSD)", "price": 101990 },
  { "name": "Dell OptiPlex 3000 Tower (Core i5/8GB/512GB SSD)", "price": 42990 },
  { "name": "Asus ExpertCenter D5 (Core i3/8GB/1TB HDD)", "price": 29990 },
  { "name": "Acer Veriton N Mini PC (Core i5/8GB/256GB SSD)", "price": 34990 },
  { "name": "MSI Cubi 5 Mini PC (Core i3/8GB/256GB SSD)", "price": 31990 },
  { "name": "Samsung Galaxy Book Desktop (Core i5/8GB/512GB SSD)", "price": 49990 },
  { "name": "Zebronics Gaming PC (Ryzen 5/16GB/512GB SSD)", "price": 39990 },
  { "name": "Intex Gaming Tower (Core i5/8GB/1TB HDD)", "price": 28990 },
  { "name": "iBall Gaming Rig (Core i7/16GB/1TB SSD)", "price": 59990 },
  { "name": "Micromax Workstation Pro (Core i5/8GB/512GB SSD)", "price": 34990 },
  { "name": "Lava Blaze PC (Celeron/4GB/128GB SSD)", "price": 7990 },
  { "name": "Reliance Jio Work PC (ARM/4GB/64GB)", "price": 8990 },
  { "name": "CHUWI LarkBox X (Ryzen 7/16GB/512GB SSD)", "price": 39990 },
  { "name": "Beelink SER5 Mini PC (Ryzen 5/16GB/512GB SSD)", "price": 37990 },
  { "name": "AXL VayuBox Pro (Core i5/8GB/512GB SSD)", "price": 29990 },
  { "name": "Futopia Creator PC (Core i7/32GB/1TB SSD)", "price": 69990 },


  { "name": "Apple Mac Mini M2 Pro (16GB/512GB SSD)", "price": 129900 },
  { "name": "Apple Mac Studio M2 Max (32GB/1TB SSD)", "price": 199900 },
  { "name": "HP All-in-One 24-cr0015in (Core i3/8GB/512GB SSD)", "price": 42990 },
  { "name": "HP Pavilion AIO 24-ca2015in (Core i5/16GB/512GB SSD)", "price": 64990 },
  { "name": "Lenovo IdeaCentre AIO 5 24IAP7 (Core i7/16GB/1TB SSD)", "price": 79990 },
  { "name": "Lenovo ThinkCentre M75s Gen 2 (Ryzen 5/8GB/512GB SSD)", "price": 44990 },
  { "name": "Dell OptiPlex 5000 Tower (Core i5/16GB/512GB SSD)", "price": 54990 },
  { "name": "Dell Inspiron 3020S (Core i3/8GB/1TB HDD)", "price": 31990 },
  { "name": "Asus Vivo AiO V222 (Pentium/4GB/1TB HDD)", "price": 28990 },
  { "name": "Asus ExpertCenter D3 Tower (Core i3/8GB/512GB SSD)", "price": 34990 },
  { "name": "Acer Aspire C22 AIO (Intel N4500/4GB/256GB SSD)", "price": 24990 },
  { "name": "Acer Veriton M Mini Tower (Core i5/8GB/1TB HDD)", "price": 39990 },
  { "name": "MSI Pro DP10 (Core i5/8GB/512GB SSD)", "price": 42990 },
  { "name": "MSI Modern AM272P AIO (Core i7/16GB/1TB SSD)", "price": 84990 },
  { "name": "Samsung Galaxy AIO Lite (Core i3/8GB/256GB SSD)", "price": 37990 },
  { "name": "Zebronics ZEB-AIO 22 (Intel N4020/4GB/128GB SSD)", "price": 19990 },
  { "name": "Intex Compact PC (Intel Atom/2GB/32GB SSD)", "price": 6990 },
  { "name": "iBall iTower 1000 (Core i3/4GB/500GB HDD)", "price": 9990 },
  { "name": "Micromax Alpha Mini PC (Celeron/4GB/128GB SSD)", "price": 8490 },
  { "name": "Lava Blaze Workstation (Intel N100/4GB/128GB SSD)", "price": 7990 },
  { "name": "Reliance Jio Creator PC (ARM/4GB/64GB)", "price": 8990 },
  { "name": "CHUWI LarkBox Mini PC (Intel Celeron/6GB/128GB SSD)", "price": 13990 },
  { "name": "Beelink EQ12 Mini PC (Intel N100/8GB/256GB SSD)", "price": 16990 },
  { "name": "Primebook Desktop Lite (Android/4GB/64GB)", "price": 8990 },
  { "name": "Wings Workstation W3 (Core i3/8GB/256GB SSD)", "price": 19990 },
  { "name": "AXL VayuBox Lite (Intel N4020/4GB/128GB SSD)", "price": 10990 },
  { "name": "Futopia BasicBox (Pentium/4GB/500GB HDD)", "price": 8990 },
  { "name": "Gigabyte BRIX Pro (Core i7/16GB/512GB SSD)", "price": 59990 },
  { "name": "CHUWI CoreBox Lite (Core i3/8GB/256GB SSD)", "price": 29990 },
  { "name": "Walker EduPC (Intel Atom/2GB/32GB SSD)", "price": 5990 },
  { "name": "RDP Workstation 1110 (Intel Celeron/4GB/128GB SSD)", "price": 9990 },
  { "name": "IBall iTower 5000 (Core i5/8GB/1TB HDD)", "price": 24990 },
  { "name": "HCL ME Office PC (Core i3/8GB/500GB HDD)", "price": 19990 },
  { "name": "Sony VAIO Desktop Fit Series (Core i5/8GB/1TB HDD)", "price": 39990 },
  { "name": "Toshiba Satellite Tower (Core i3/4GB/500GB HDD)", "price": 28990 },
  { "name": "Panasonic ToughStation Lite (Core i3/8GB/256GB SSD)", "price": 34990 },
  { "name": "LG Ultra PC Mini (Core i3/8GB/256GB SSD)", "price": 29990 },
  { "name": "Microsoft Surface Studio Go (Core i5/8GB/256GB SSD)", "price": 69990 },
  { "name": "HP ProOne 240 G9 AIO (Core i3/8GB/512GB SSD)", "price": 42990 },
  { "name": "Lenovo ThinkCentre M70q Tiny (Core i5/8GB/512GB SSD)", "price": 39990 },
  { "name": "Dell Precision 3480 Tower (Core i5/16GB/512GB SSD)", "price": 59990 },
  { "name": "Asus Mini PC PN42 (Intel N100/8GB/256GB SSD)", "price": 21990 },
  { "name": "Acer Aspire XC-895 (Core i3/8GB/1TB HDD)", "price": 31990 },
  { "name": "MSI Cubi N Mini PC (Intel N200/8GB/256GB SSD)", "price": 23990 },
  { "name": "Samsung Galaxy AIO Creator Edition (Core i7/32GB/1TB SSD)", "price": 79990 },
  { "name": "Zebronics ZEB-Gaming PC ZG-2 (Ryzen 5/16GB/512GB SSD)", "price": 44990 },
  { "name": "Intex CreatorBox Pro (Core i7/16GB/1TB SSD)", "price": 49990 },
  { "name": "iBall CreatorBox Max (Core i9/32GB/1TB SSD)", "price": 89990 },



  { "name": "Apple iMac Pro (Xeon W/32GB/1TB SSD)", "price": 249900 },
  { "name": "Apple Mac Pro Tower (M2 Ultra/64GB/2TB SSD)", "price": 499900 },
  { "name": "HP Z2 G9 Tower Workstation (Core i9/32GB/1TB SSD)", "price": 139990 },
  { "name": "HP EliteDesk 800 G9 Mini (Core i5/16GB/512GB SSD)", "price": 64990 },
  { "name": "Lenovo Legion T5 Gaming (Ryzen 7/16GB/1TB SSD)", "price": 89990 },
  { "name": "Lenovo ThinkCentre M90t Tower (Core i7/16GB/1TB SSD)", "price": 79990 },
  { "name": "Dell XPS Desktop 8960 (Core i9/32GB/2TB SSD)", "price": 159990 },
  { "name": "Dell Precision 5820 Tower (Xeon/32GB/1TB SSD)", "price": 189990 },
  { "name": "Asus ROG G22CH Gaming PC (Core i7/16GB/1TB SSD)", "price": 99990 },
  { "name": "Asus ProArt Station PD5 (Core i9/32GB/1TB SSD)", "price": 139990 },
  { "name": "Acer Predator Orion 7000 (Core i9/32GB/2TB SSD)", "price": 179990 },
  { "name": "Acer Aspire TC-1760 (Core i5/8GB/512GB SSD)", "price": 42990 },
  { "name": "MSI MAG Infinite S3 (Core i5/16GB/512GB SSD)", "price": 59990 },
  { "name": "MSI Creator P100X (Core i9/32GB/1TB SSD)", "price": 149990 },
  { "name": "Samsung Galaxy Creator PC (Core i9/32GB/2TB SSD)", "price": 169990 },
  { "name": "Zebronics ZEB-Gaming PC ZG-3 (Ryzen 9/32GB/1TB SSD)", "price": 59990 },
  { "name": "Intex CreatorBox Max (Core i9/32GB/2TB SSD)", "price": 69990 },
  { "name": "iBall CreatorBox Elite (Core i7/16GB/1TB SSD)", "price": 49990 },
  { "name": "Lava Blaze Creator PC (Core i5/16GB/512GB SSD)", "price": 39990 },
  { "name": "Reliance Jio CreatorBox Pro (ARM/8GB/128GB)", "price": 12990 },
  { "name": "CHUWI CoreBox Elite (Core i9/32GB/1TB SSD)", "price": 59990 },
  { "name": "Beelink SER7 Mini PC (Ryzen 7/32GB/1TB SSD)", "price": 49990 },
  { "name": "Primebook Desktop Creator Edition (Android/8GB/128GB)", "price": 14990 },
  { "name": "Wings Workstation W4 (Core i7/16GB/1TB SSD)", "price": 44990 },
  { "name": "AXL VayuBox Creator (Core i9/32GB/1TB SSD)", "price": 59990 },
  { "name": "Futopia CreatorBox Elite (Ryzen 9/32GB/2TB SSD)", "price": 79990 },
  { "name": "Gigabyte AERO Creator PC (Core i9/32GB/1TB SSD)", "price": 99990 },
  { "name": "Walker Creator PC (Core i7/16GB/1TB SSD)", "price": 44990 },
  { "name": "RDP CreatorBox 2025 (Core i5/16GB/512GB SSD)", "price": 34990 },
  { "name": "IBall CreatorBox Ultra (Core i9/32GB/2TB SSD)", "price": 89990 },
  { "name": "HCL ME CreatorBox Z3 (Core i7/16GB/1TB SSD)", "price": 49990 },
  { "name": "Sony VAIO Creator PC (Core i9/32GB/1TB SSD)", "price": 99990 },
  { "name": "Toshiba Satellite Creator Edition (Core i7/16GB/1TB SSD)", "price": 69990 },
  { "name": "Panasonic ToughStation Creator (Core i9/32GB/1TB SSD)", "price": 99990 },
  { "name": "LG Ultra Creator PC (Core i7/16GB/1TB SSD)", "price": 79990 },
  { "name": "Microsoft Surface Studio Creator Edition (Core i9/32GB/1TB SSD)", "price": 199990 },
  { "name": "HP Z8 G5 Workstation (Xeon/64GB/2TB SSD)", "price": 299990 },
  { "name": "Lenovo ThinkStation P5 (Xeon/32GB/1TB SSD)", "price": 189990 },
  { "name": "Dell Precision 7960 Tower (Xeon/64GB/2TB SSD)", "price": 299990 },
  { "name": "Asus ROG Strix Creator PC (Ryzen 9/32GB/2TB SSD)", "price": 149990 },
  { "name": "Acer ConceptD 500 Creator PC (Core i9/32GB/1TB SSD)", "price": 129990 },
  { "name": "MSI Creator P50 (Core i7/16GB/1TB SSD)", "price": 99990 },
  { "name": "Samsung Galaxy CreatorBox Max (Core i9/64GB/2TB SSD)", "price": 199990 },
  { "name": "Zebronics ZEB-Creator PC ZC-1 (Core i9/32GB/1TB SSD)", "price": 69990 },
  { "name": "Intex CreatorBox Ultra (Core i9/32GB/2TB SSD)", "price": 79990 },
  { "name": "iBall CreatorBox Titan (Core i9/64GB/2TB SSD)", "price": 99990 },
  { "name": "Lava Blaze CreatorBox Pro (Core i7/16GB/1TB SSD)", "price": 49990 },
  { "name": "Reliance Jio CreatorBox Max (ARM/8GB/256GB)", "price": 14990 },

                

              ],
            
            
    
              
                "Tabs": [
                    { "name": "Apple iPad Air M2", "price": 59999 },
  { "name": "Apple iPad Pro M4 11-inch", "price": 99900 },
  { "name": "Apple iPad Mini A17", "price": 49900 },
  { "name": "Samsung Galaxy Tab S9 FE+", "price": 44999 },
  { "name": "Samsung Galaxy Tab A9+", "price": 18999 },
  { "name": "Samsung Galaxy Tab S8 Ultra", "price": 89999 },
  { "name": "Samsung Galaxy Tab Active4 Pro", "price": 64999 },
  { "name": "Realme Pad 2", "price": 19999 },
  { "name": "Realme Pad X", "price": 25999 },
  { "name": "Realme Pad Mini", "price": 12999 },
  { "name": "Lenovo Tab P12", "price": 24999 },
  { "name": "Lenovo Tab M10 5G", "price": 17999 },
  { "name": "Lenovo Yoga Tab 13", "price": 49999 },
  { "name": "Lenovo Tab M9", "price": 10999 },
  { "name": "Xiaomi Pad 6", "price": 26999 },
  { "name": "Xiaomi Pad 5", "price": 24999 },
  { "name": "Honor Pad X9", "price": 15999 },
  { "name": "Honor Pad 8", "price": 18999 },
  { "name": "Motorola Tab G70", "price": 21999 },
  { "name": "Motorola Tab G62 LTE", "price": 17999 },
  { "name": "OnePlus Pad", "price": 37999 },
  { "name": "OnePlus Pad Go", "price": 16999 },
  { "name": "Nokia T21", "price": 17999 },
  { "name": "Nokia T10", "price": 12999 },
  { "name": "Micromax Canvas Tab P702", "price": 7499 },
  { "name": "Micromax Fantabulet F666", "price": 6999 },
  { "name": "Lava Magnum XL", "price": 9999 },
  { "name": "Lava Ivory E", "price": 7999 },
  { "name": "iBall Slide Wings 4GP", "price": 8499 },
  { "name": "iBall Slide Elan 3x32", "price": 9999 },
  { "name": "Alcatel 3T 10", "price": 8999 },
  { "name": "Alcatel 1T 7", "price": 5999 },
  { "name": "Huawei MatePad 11", "price": 34999 },
  { "name": "Huawei MatePad T10s", "price": 15999 },
  { "name": "Asus ZenPad 3S 10", "price": 27999 },
  { "name": "Asus ROG Flow Z13", "price": 99999 },
  { "name": "Dell Latitude 7320 Detachable", "price": 89999 },
  { "name": "HP Elite x2 G8", "price": 84999 },
  { "name": "Microsoft Surface Pro 9", "price": 99999 },
  { "name": "Microsoft Surface Go 3", "price": 42999 },
  { "name": "Amazon Fire HD 10", "price": 14999 },
  { "name": "Amazon Fire HD 8", "price": 9999 },
  { "name": "Amazon Fire 7", "price": 6999 },
  { "name": "TCL Tab 10s", "price": 13999 },
  { "name": "TCL Tab 8", "price": 8999 },
  { "name": "Zebronics Zebpad 7T20", "price": 5999 },
  { "name": "Swipe Slate 3", "price": 7999 },
  { "name": "Swipe X703", "price": 6999 },
  { "name": "Panasonic Tab 8 HD", "price": 9999 },


  { "name": "Panasonic Toughpad FZ-B2", "price": 49999 },
  { "name": "Sony Xperia Z4 Tablet", "price": 39999 },
  { "name": "Sony Tablet S", "price": 29999 },
  { "name": "Google Pixel Tablet", "price": 49999 },
  { "name": "Google Nexus 9", "price": 24999 },
  { "name": "HTC Nexus 7", "price": 19999 },
  { "name": "HTC Flyer", "price": 14999 },
  { "name": "BlackBerry PlayBook", "price": 9999 },
  { "name": "LG G Pad 5", "price": 17999 },
  { "name": "LG G Pad 8.3", "price": 14999 },
  { "name": "Acer Iconia Tab 10", "price": 16999 },
  { "name": "Acer One 10", "price": 14999 },
  { "name": "Ulefone Tab A7", "price": 9999 },
  { "name": "Umidigi A11 Tab", "price": 10999 },
  { "name": "Doogee T30 Pro", "price": 13999 },
  { "name": "Cubot Tab 10", "price": 8999 },
  { "name": "Fairphone Tab 1", "price": 19999 },
  { "name": "Chuwi HiPad XPro", "price": 14999 },
  { "name": "Chuwi UBook X", "price": 24999 },
  { "name": "Teclast T40 Pro", "price": 16999 },
  { "name": "Teclast M40 Air", "price": 13999 },
  { "name": "Fusion5 104EvII Pro", "price": 9999 },
  { "name": "Fusion5 108", "price": 8999 },
  { "name": "Digiflip Pro XT712", "price": 7999 },
  { "name": "Digiflip Pro ET701", "price": 6999 },
  { "name": "Zync Quad 10.1", "price": 8499 },
  { "name": "Zync Z909 Plus", "price": 5999 },
  { "name": "Karbonn ST72", "price": 4999 },
  { "name": "Karbonn TA-F01", "price": 5999 },
  { "name": "Celkon CT722", "price": 6999 },
  { "name": "Celkon CT111", "price": 5999 },
  { "name": "Maxx Tab GenxDroid7", "price": 4999 },
  { "name": "Spice Mi-1010 Stellar Pad", "price": 7999 },
  { "name": "I Kall N9", "price": 4999 },
  { "name": "I Kall N7", "price": 3999 },
  { "name": "LeEco LePad", "price": 14999 },
  { "name": "Coolpad Tab 8", "price": 8999 },
  { "name": "Meizu MPad", "price": 12999 },
  { "name": "ZTE ZPad 10", "price": 10999 },
  { "name": "Philips Tab 10", "price": 9999 },
  { "name": "Sharp Tab 8", "price": 8999 },
  { "name": "Toshiba Excite 10", "price": 13999 },
  { "name": "Toshiba Thrive", "price": 11999 },
  { "name": "ViewSonic ViewPad 10", "price": 9999 },
  { "name": "Archos 101 Oxygen", "price": 8999 },
  { "name": "Prestigio MultiPad 4", "price": 7999 },
  { "name": "Wishtel IRA", "price": 4999 },
  { "name": "Datawind Ubislate 7C+", "price": 2999 },
  { "name": "Datawind Ubislate 10Ci", "price": 3999 },


  { "name": "Apple iPad (11th Gen)", "price": 34900 },
  { "name": "Apple iPad (10th Gen)", "price": 29900 },
  { "name": "Apple iPad (9th Gen)", "price": 27900 },
  { "name": "Apple iPad (8th Gen)", "price": 25900 },
  { "name": "Apple iPad (7th Gen)", "price": 23900 },
  { "name": "Apple iPad (6th Gen)", "price": 21900 },
  { "name": "Apple iPad (5th Gen)", "price": 19900 },
  { "name": "Apple iPad Pro 11 (M4)", "price": 109900 },
  { "name": "Apple iPad Pro 13 (M4)", "price": 124900 },
  { "name": "Apple iPad Air (5th Gen)", "price": 69900 },
  { "name": "Apple iPad Mini (6th Gen)", "price": 49900 },
  { "name": "Samsung Galaxy Tab S7 FE", "price": 39999 },
  { "name": "Samsung Galaxy Tab S6 Lite", "price": 24999 },
  { "name": "Samsung Galaxy Tab A8", "price": 17999 },
  { "name": "Samsung Galaxy Tab A7", "price": 15999 },
  { "name": "Samsung Galaxy Tab E", "price": 12999 },
  { "name": "Realme Pad Mini LTE", "price": 12999 },
  { "name": "Realme Pad LTE", "price": 15999 },
  { "name": "Realme Pad X 5G", "price": 25999 },
  { "name": "Lenovo Tab M10 FHD Plus", "price": 14999 },
  { "name": "Lenovo Tab M8 HD", "price": 9999 },
  { "name": "Lenovo Tab V7", "price": 10999 },
  { "name": "Lenovo Tab P11", "price": 22999 },
  { "name": "Xiaomi Mi Pad 4", "price": 17999 },
  { "name": "Xiaomi Mi Pad 5 Pro", "price": 29999 },
  { "name": "Honor Pad V8 Pro", "price": 34999 },
  { "name": "Honor Pad 5", "price": 14999 },
  { "name": "Motorola Tab G20", "price": 10999 },
  { "name": "Motorola Tab G62", "price": 15999 },
  { "name": "Nokia T20", "price": 14999 },
  { "name": "Nokia T10 LTE", "price": 12999 },
  { "name": "Micromax Canvas Tab P681", "price": 7999 },
  { "name": "Micromax Canvas Tab P480", "price": 6999 },
  { "name": "Lava Ivory M4", "price": 7999 },
  { "name": "Lava Twinpad", "price": 9999 },
  { "name": "iBall Slide Gorgeo 4GL", "price": 6999 },
  { "name": "iBall Slide Nimble 4GF", "price": 8499 },
  { "name": "Alcatel A3 10", "price": 8999 },
  { "name": "Alcatel Pop 7 LTE", "price": 7499 },
  { "name": "Huawei MediaPad T5", "price": 14999 },
  { "name": "Huawei MediaPad M5 Lite", "price": 17999 },
  { "name": "Asus ZenPad 10", "price": 18999 },
  { "name": "Asus Transformer Pad TF103", "price": 16999 },
  { "name": "Amazon Fire HD 10 Kids", "price": 12999 },
  { "name": "Amazon Fire HD 8 Kids", "price": 9999 },
  { "name": "TCL Tab 10L", "price": 10999 },
  { "name": "TCL TabMax 10.4", "price": 14999 },
  { "name": "Zebronics Zebpad 10", "price": 6999 },
  { "name": "Swipe Slate Pro", "price": 8999 },


                  ],


                
                "Computer System/ Laptop Accessories": [
   { "name": "Dell 24-inch Full HD Monitor SE2422H", "price": 9999 },
  { "name": "Samsung 27-inch Curved Monitor LC27F390FHWXXL", "price": 13999 },
  { "name": "LG 32-inch UltraGear Gaming Monitor 32GN650", "price": 22999 },
  { "name": "HP 21.5-inch Monitor M22f", "price": 8999 },
  { "name": "Lenovo L24i-30 23.8-inch Monitor", "price": 10999 },
  { "name": "Zebronics 24-inch LED Monitor ZEB-A24FHD", "price": 7999 },
  { "name": "Acer Nitro VG240Y 23.8-inch Gaming Monitor", "price": 12999 },
  { "name": "BenQ GW2480 24-inch Eye-Care Monitor", "price": 10999 },
  { "name": "ViewSonic VA2215-H 22-inch Monitor", "price": 8499 },
  { "name": "MSI PRO MP241X 24-inch Monitor", "price": 9999 },
  { "name": "Logitech K120 Wired Keyboard", "price": 699 },
  { "name": "HP K150 Wired Keyboard", "price": 599 },
  { "name": "Dell KB216 Wired Keyboard", "price": 799 },
  { "name": "Zebronics ZEB-KM2100 Keyboard", "price": 499 },
  { "name": "Logitech MK235 Wireless Keyboard & Mouse Combo", "price": 1499 },
  { "name": "HP 330 Wireless Keyboard & Mouse Combo", "price": 1699 },
  { "name": "Dell MS116 Wired Optical Mouse", "price": 499 },
  { "name": "Logitech M331 Silent Wireless Mouse", "price": 1299 },
  { "name": "Zebronics Zeb-Transformer Gaming Mouse", "price": 899 },
  { "name": "Redragon M612 Predator Gaming Mouse", "price": 1299 },
  { "name": "Canon PIXMA G3020 All-in-One Ink Tank Printer", "price": 14999 },
  { "name": "HP DeskJet 2331 All-in-One Printer", "price": 4999 },
  { "name": "Epson EcoTank L3250 Wi-Fi All-in-One Printer", "price": 13999 },
  { "name": "Brother HL-L2321D Laser Printer", "price": 9999 },
  { "name": "Pantum P2500W Monochrome Laser Printer", "price": 6999 },
  { "name": "TP-Link Archer C6 Wi-Fi Router", "price": 2299 },
  { "name": "D-Link DIR-615 Wireless N Router", "price": 1799 },
  { "name": "Netgear R6120 Dual Band Router", "price": 2499 },
  { "name": "Zebronics ZEB-UPS U725 UPS", "price": 2499 },
  { "name": "APC BX600C-IN 600VA UPS", "price": 3499 },
  { "name": "Portronics UFO PRO 6-Port Charging Station", "price": 999 },
  { "name": "SanDisk Ultra Flair 64GB USB 3.0 Pen Drive", "price": 599 },
  { "name": "WD Elements 1TB External Hard Drive", "price": 3999 },
  { "name": "Seagate Backup Plus Slim 2TB HDD", "price": 5999 },
  { "name": "Logitech C270 HD Webcam", "price": 1799 },
  { "name": "Zebronics Zeb-Crystal Plus Webcam", "price": 999 },
  { "name": "HP H2800 Wired Headset", "price": 1299 },
  { "name": "boAt BassHeads 900 Wired Headphones", "price": 999 },
  { "name": "Logitech Z120 Stereo Speakers", "price": 999 },
  { "name": "Creative Pebble 2.0 USB Speakers", "price": 1799 },
  { "name": "Lapcare Cooling Pad with Dual Fans", "price": 799 },
  { "name": "AmazonBasics Laptop Stand", "price": 999 },
  { "name": "Targus 15.6-inch Laptop Backpack", "price": 1499 },
  { "name": "Wildcraft 30L Laptop Backpack", "price": 1799 },
  { "name": "Portronics My Buddy Plus Laptop Table", "price": 1299 },
  { "name": "Amkette Ergo View Laptop Stand", "price": 1499 },
  { "name": "Quantum QHMPL USB Hub 4-Port", "price": 299 },
  { "name": "TP-Link USB to Ethernet Adapter", "price": 899 },
  { "name": "Zebronics ZEB-CC132 HDMI Cable 1.5m", "price": 299 },
  { "name": "Portronics Konnect L USB Type-C Cable", "price": 199 },


  { "name": "Lenovo Legion H300 Gaming Headset", "price": 2999 },
  { "name": "Logitech G402 Hyperion Fury Gaming Mouse", "price": 2499 },
  { "name": "Redragon K552 Mechanical Gaming Keyboard", "price": 2999 },
  { "name": "HP Omen Vector RGB Gaming Mouse", "price": 3499 },
  { "name": "Dell Premier Wireless Keyboard & Mouse KM7321W", "price": 5999 },
  { "name": "Logitech MX Keys Advanced Wireless Keyboard", "price": 8499 },
  { "name": "Razer DeathAdder V2 Gaming Mouse", "price": 3999 },
  { "name": "Corsair K55 RGB Pro Keyboard", "price": 4499 },
  { "name": "HyperX Pulsefire Core RGB Mouse", "price": 2999 },
  { "name": "SteelSeries Apex 3 RGB Gaming Keyboard", "price": 4999 },
  { "name": "Canon imageCLASS LBP6030W Laser Printer", "price": 10999 },
  { "name": "HP LaserJet MFP M1005 Printer", "price": 18999 },
  { "name": "Epson L805 Photo Ink Tank Printer", "price": 18990 },
  { "name": "Brother DCP-T420W Ink Tank Printer", "price": 12999 },
  { "name": "Zebronics ZEB-UPS U725VA", "price": 2999 },
  { "name": "APC Back-UPS BX1100C-IN", "price": 4999 },
  { "name": "TP-Link Deco M4 Mesh Wi-Fi System", "price": 6999 },
  { "name": "Netgear Nighthawk AX1800 Router", "price": 7999 },
  { "name": "D-Link DIR-X1560 AX1500 Router", "price": 5999 },
  { "name": "Tenda AC10 Dual Band Router", "price": 2999 },
  { "name": "Logitech Z313 Speaker System", "price": 3499 },
  { "name": "Creative SBS E2800 2.1 Speakers", "price": 3999 },
  { "name": "boAt Stone 650 Bluetooth Speaker", "price": 1999 },
  { "name": "JBL Go 3 Portable Speaker", "price": 2999 },
  { "name": "Portronics SoundDrum P Wireless Speaker", "price": 1799 },
  { "name": "SanDisk Extreme Pro 128GB USB 3.2", "price": 1499 },
  { "name": "Samsung T7 Shield 1TB Portable SSD", "price": 8999 },
  { "name": "WD My Passport 4TB External HDD", "price": 8999 },
  { "name": "Seagate Expansion 2TB HDD", "price": 5999 },
  { "name": "Transcend JetFlash 790K 64GB USB", "price": 799 },
  { "name": "Logitech C920 HD Pro Webcam", "price": 5999 },
  { "name": "HP W300 Webcam", "price": 2499 },
  { "name": "Zebronics Zeb-Ultimate Plus Webcam", "price": 1999 },
  { "name": "Lenovo 300 FHD Webcam", "price": 2999 },
  { "name": "Lapcare Ergonomic Cooling Pad", "price": 999 },
  { "name": "Cooler Master Notepal X3 Cooling Pad", "price": 2999 },
  { "name": "Amkette Ergo View Pro Laptop Stand", "price": 1999 },
  { "name": "Portronics My Buddy K Laptop Table", "price": 1499 },
  { "name": "AmazonBasics 15.6-inch Laptop Bag", "price": 1299 },
  { "name": "Skybags Campus Laptop Backpack", "price": 1799 },
  { "name": "Wildcraft Workpack 25L", "price": 1499 },
  { "name": "Targus TSB921 Backpack", "price": 1999 },
  { "name": "Quantum QHMPL USB Hub 7-Port", "price": 499 },
  { "name": "TP-Link UE300 USB 3.0 to Ethernet Adapter", "price": 1299 },
  { "name": "Belkin HDMI Cable 2m", "price": 499 },
  { "name": "Portronics Konnect L 60W Type-C Cable", "price": 299 },
  { "name": "Ambrane 3A Fast Charging Micro USB Cable", "price": 199 },
  { "name": "Lapcare Keyboard Skin Protector", "price": 199 },
  { "name": "Zebronics Gaming Mouse Pad XL", "price": 399 },
  { "name": "STRIFF RGB Extended Mouse Pad", "price": 599 },



  { "name": "Logitech MX Master 3S Wireless Mouse", "price": 8999 },
  { "name": "Keychron K2 V2 Mechanical Keyboard", "price": 5999 },
  { "name": "SteelSeries Apex Pro TKL Gaming Keyboard", "price": 15499 },
  { "name": "Razer DeathAdder V3 Pro Wireless Mouse", "price": 8499 },
  { "name": "HyperX QuadCast S USB Microphone", "price": 9999 },
  { "name": "Sony WH-1000XM5 Noise Cancelling Headphones", "price": 29999 },
  { "name": "Bose QuietComfort 45 Bluetooth Headphones", "price": 32900 },
  { "name": "Anker Soundcore 2 Bluetooth Speaker", "price": 3999 },
  { "name": "HUANUO Dual Monitor Arm Stand", "price": 6499 },
  { "name": "Lamicall Adjustable Laptop Stand", "price": 3599 },
  { "name": "Ergonomic Gel Mouse Pad with Wrist Rest", "price": 699 },
  { "name": "Large Extended Gaming Mouse Pad XXL", "price": 999 },
  { "name": "Blue Light Blocking Glasses", "price": 1499 },
  { "name": "Foot Rest Cushion for Under Desk", "price": 2999 },
  { "name": "Keyboard & Mouse Wrist Rest Pad Set", "price": 999 },
  { "name": "SanDisk Ultra Fit 128GB USB 3.1 Drive", "price": 1401 },
  { "name": "Samsung T7 Shield 1TB Portable SSD", "price": 8999 },
  { "name": "TP-Link Archer T3U Plus USB Wi-Fi Adapter", "price": 1499 },
  { "name": "Cable Matters USB to Ethernet Adapter", "price": 2279 },
  { "name": "Anker 7-in-1 USB-C Hub", "price": 3499 },
  { "name": "Portronics Clamp M4 Car Phone Holder", "price": 296 },
  { "name": "STRIFF World Map Gaming Mouse Pad", "price": 229 },
  { "name": "Tygot Bluetooth Selfie Stick Tripod", "price": 269 },
  { "name": "Fujifilm Instax Mini Film (20 Shots)", "price": 1399 },
  { "name": "Robustrion Tempered Glass for iPad 11th Gen", "price": 399 },
  { "name": "Ambrane Aerosync Snap 10000mAh Power Bank", "price": 1499 },
  { "name": "Portronics Toad 23 Wireless Mouse", "price": 299 },
  { "name": "Portronics MODESK Universal Mobile Holder", "price": 119 },
  { "name": "Ambrane Twistand Mobile Stand", "price": 134 },
  { "name": "Cubiker Foldable Laptop Table", "price": 549 },
  { "name": "Safari Omega Laptop Backpack 30L", "price": 699 },
  { "name": "Portronics Bridge Y USB-C OTG Adapter", "price": 119 },
  { "name": "Ambrane Type-C to Lightning Cable", "price": 349 },
  { "name": "Kratos K2 Selfie Stick with LED Light", "price": 319 },
  { "name": "Ambrane USB to Lightning Cable", "price": 179 },
  { "name": "Sounce 3-in-1 Screen Cleaning Kit", "price": 149 },
  { "name": "Samsung EVO Plus 128GB microSD Card", "price": 1099 },
  { "name": "Logitech M186 Wireless Mouse", "price": 549 },
  { "name": "Portronics iKonnect C Pro Audio Adapter", "price": 218 },
  { "name": "65W SuperVOOC Fast Charger", "price": 573 },
  { "name": "Dyazo Laptop Sleeve 15.6-inch", "price": 299 },
  { "name": "Dyazo Adjustable Aluminum Laptop Stand", "price": 379 },
  { "name": "Ambrane Braided Micro USB Cable", "price": 149 },
  { "name": "Portronics Toad One Bluetooth Mouse", "price": 644 },
  { "name": "Syvo WT3130 Tripod Stand", "price": 799 },
  { "name": "Tygot LED Ring Light with Tripod", "price": 549 },
  { "name": "Basesailor Type-C to Audio Jack Adapter", "price": 219 },
  { "name": "DIGIROOT Stylus Pen for iPad", "price": 1499 },
  { "name": "Oakter Mini UPS for Wi-Fi Router", "price": 1299 },


],

        "Smart watches and wearable": [
               
            { "name": "Apple Watch Series 9 GPS 41mm", "price": 41900 },
  { "name": "Samsung Galaxy Watch6 Classic LTE 47mm", "price": 39999 },
  { "name": "OnePlus Watch 2", "price": 24999 },
  { "name": "NoiseFit Halo Plus", "price": 1999 },
  { "name": "boAt Lunar Comet", "price": 1499 },
  { "name": "Fire-Boltt Phoenix Pro", "price": 1799 },
  { "name": "CMF Watch Pro", "price": 2499 },
  { "name": "Boult Drift+", "price": 1099 },
  { "name": "Redmi Watch 3 Active", "price": 2499 },
  { "name": "Fitbit Charge 6", "price": 8299 },
  { "name": "Garmin Venu Sq 2", "price": 22999 },
  { "name": "Amazfit GTR 4", "price": 17999 },
  { "name": "Huawei Band 10", "price": 3599 },
  { "name": "Xiaomi Mi Smart Band 6", "price": 3280 },
  { "name": "GOQii Vital 3.0", "price": 1049 },
  { "name": "Amazfit Band 7", "price": 3999 },
  { "name": "Fitbit Inspire 3", "price": 8299 },
  { "name": "Boult Trail Smart Watch", "price": 1099 },
  { "name": "Huawei Band 9", "price": 3999 },
  { "name": "Realme Band 2", "price": 2499 },
  { "name": "Honor Band 6", "price": 2999 },
  { "name": "Samsung Galaxy Fit2", "price": 3999 },
  { "name": "Noise ColorFit Pulse Go Buzz", "price": 1299 },
  { "name": "Fire-Boltt Ninja Call Pro", "price": 1499 },
  { "name": "boAt Wave Call 2", "price": 1299 },
  { "name": "Fastrack Reflex Vox", "price": 1999 },
  { "name": "Titan Smart Pro", "price": 9999 },
  { "name": "Zebronics Zeb-Fit1220CH", "price": 1799 },
  { "name": "Crossbeats Ignite S5", "price": 2999 },
  { "name": "TAGG Verve Engage", "price": 1499 },
  { "name": "Dizo Watch D Plus", "price": 1999 },
  { "name": "Realme Watch 3 Pro", "price": 4499 },
  { "name": "NoiseFit Force", "price": 1999 },
  { "name": "Fire-Boltt Visionary", "price": 2499 },
  { "name": "boAt Xtend Talk", "price": 2299 },
  { "name": "Fitshot Axis", "price": 1499 },
  { "name": "Pebble Cosmos Luxe", "price": 2999 },
  { "name": "Inbase Urban Fit S", "price": 1799 },
  { "name": "Portronics Kronos X4", "price": 1999 },
  { "name": "Syska SW300", "price": 1899 },
  { "name": "Ubon SW-81", "price": 1499 },
  { "name": "Hammer Pulse X", "price": 1699 },
  { "name": "Cult Sport Beats", "price": 1999 },
  { "name": "Reebok ActiveFit 1.0", "price": 2499 },
  { "name": "Timex Fit 2.0", "price": 2999 },
  { "name": "Maxima Max Pro X5", "price": 1899 },
  { "name": "HEDU AMOLED BT Calling Watch", "price": 747 },
  { "name": "Truetag Smart Watch", "price": 570 },
  { "name": "Cadnut LED BT Calling Watch", "price": 372 },
  { "name": "VEhop HD-IPS Smart Watch", "price": 682 },


  { "name": "Apple Watch SE (2nd Gen)", "price": 29900 },
  { "name": "Samsung Galaxy Watch7 LTE 44mm", "price": 19999 },
  { "name": "Google Pixel Watch 3", "price": 34999 },
  { "name": "Amazfit Bip 6", "price": 6699 },
  { "name": "Amazfit Balance 2", "price": 10999 },
  { "name": "Amazfit Falcon", "price": 18999 },
  { "name": "Amazfit Cheetah Pro", "price": 14999 },
  { "name": "Amazfit T-Rex Ultra", "price": 15999 },
  { "name": "Amazfit Active 2", "price": 9999 },
  { "name": "Withings ScanWatch 2", "price": 17999 },
  { "name": "Pebble Cosmos Endure", "price": 2999 },
  { "name": "Pebble Frost", "price": 1999 },
  { "name": "NoiseFit Twist", "price": 1399 },
  { "name": "NoiseFit Crew", "price": 1699 },
  { "name": "NoiseFit Icon Buzz", "price": 1499 },
  { "name": "NoiseFit Evolve 3", "price": 2999 },
  { "name": "Fire-Boltt Ninja 3", "price": 1299 },
  { "name": "Fire-Boltt Ring 3", "price": 1499 },
  { "name": "Fire-Boltt Hunter", "price": 1099 },
  { "name": "boAt Ultima Call", "price": 1299 },
  { "name": "boAt Wave Fury", "price": 1099 },
  { "name": "boAt Storm Infinity", "price": 1199 },
  { "name": "boAt Ultima Prism", "price": 1199 },
  { "name": "Fastrack Limitless FS2 Pro", "price": 2995 },
  { "name": "Fastrack Astor FS1 Pro", "price": 2199 },
  { "name": "Fastrack Revoltt XR1", "price": 1499 },
  { "name": "TAGG Verve Sense", "price": 1399 },
  { "name": "TAGG Verve Max Buzz", "price": 1499 },
  { "name": "Crossbeats Ignite Pingg", "price": 1799 },
  { "name": "Crossbeats Orbit Apex", "price": 2499 },
  { "name": "Dizo Watch D", "price": 1999 },
  { "name": "Dizo Watch R Talk", "price": 2999 },
  { "name": "Realme Watch 2 Pro", "price": 3499 },
  { "name": "Realme Watch T1", "price": 4999 },
  { "name": "Titan Smart 2", "price": 6999 },
  { "name": "Titan Smart Touch", "price": 5999 },
  { "name": "Zebronics Zeb-Fit920CH", "price": 1599 },
  { "name": "Zebronics Zeb-Fit2220CH", "price": 1899 },
  { "name": "Portronics Kronos Beta", "price": 1799 },
  { "name": "Portronics Yogg Kronos", "price": 1499 },
  { "name": "Syska SW200", "price": 1699 },
  { "name": "Ubon SW-71", "price": 1299 },
  { "name": "Hammer Pulse 3.0", "price": 1499 },
  { "name": "Cult Sport Burn", "price": 1999 },
  { "name": "Reebok ActiveFit 2.0", "price": 2799 },
  { "name": "Timex Fit 3.0", "price": 3499 },
  { "name": "Maxima Max Pro X6", "price": 1999 },
  { "name": "HEDU Smart Watch 2.0", "price": 799 },
  { "name": "Cadnut Smart Band T500", "price": 499 },


  { "name": "Apple Watch Series 10 GPS 45mm", "price": 47900 },
  { "name": "Samsung Galaxy Watch6 LTE 40mm", "price": 34999 },
  { "name": "Google Pixel Watch 2", "price": 32999 },
  { "name": "Amazfit GTS 4 Mini", "price": 6999 },
  { "name": "Amazfit Pop 3R", "price": 3499 },
  { "name": "Amazfit Bip U Pro", "price": 4999 },
  { "name": "Amazfit Neo", "price": 1999 },
  { "name": "Withings Steel HR", "price": 8999 },
  { "name": "Withings Move ECG", "price": 7999 },
  { "name": "Pebble Cosmos Luxe Pro", "price": 3499 },
  { "name": "Pebble Pace Pro", "price": 1999 },
  { "name": "NoiseFit Diva", "price": 2999 },
  { "name": "NoiseFit Crew Go", "price": 1699 },
  { "name": "NoiseFit Nova", "price": 2499 },
  { "name": "NoiseFit Origin", "price": 2999 },
  { "name": "Fire-Boltt Phoenix AMOLED", "price": 2299 },
  { "name": "Fire-Boltt Quantum", "price": 1999 },
  { "name": "Fire-Boltt Invincible Plus", "price": 3499 },
  { "name": "Fire-Boltt Rage", "price": 1499 },
  { "name": "boAt Lunar Call Pro", "price": 1599 },
  { "name": "boAt Wave Electra", "price": 1399 },
  { "name": "boAt Storm Call 2", "price": 1299 },
  { "name": "boAt Enigma X600", "price": 1999 },
  { "name": "Fastrack Reflex Nitro", "price": 2499 },
  { "name": "Fastrack Reflex Play+", "price": 2999 },
  { "name": "TAGG Verve Connect", "price": 1599 },
  { "name": "TAGG Verve Neo", "price": 1399 },
  { "name": "Crossbeats Ignite Atlas", "price": 2799 },
  { "name": "Crossbeats Orbit X", "price": 3499 },
  { "name": "Dizo Watch D Ultra", "price": 2499 },
  { "name": "Dizo Watch R", "price": 2999 },
  { "name": "Realme Watch 2", "price": 2999 },
  { "name": "Realme Watch S", "price": 4999 },
  { "name": "Titan Smart Touch Pro", "price": 7999 },
  { "name": "Titan Smart Fit", "price": 5999 },
  { "name": "Zebronics Zeb-Fit2220CH Pro", "price": 1999 },
  { "name": "Zebronics Zeb-Fit920CH Max", "price": 1799 },
  { "name": "Portronics Kronos Y1", "price": 1499 },
  { "name": "Portronics Yogg Plus", "price": 1299 },
  { "name": "Syska SW400", "price": 1999 },
  { "name": "Ubon SW-91", "price": 1399 },
  { "name": "Hammer Pulse Lite", "price": 1299 },
  { "name": "Cult Sport Surge", "price": 1799 },
  { "name": "Reebok ActiveFit 3.0", "price": 2999 },
  { "name": "Timex Fit 4.0", "price": 3999 },
  { "name": "Maxima Max Pro X7", "price": 2199 },
  { "name": "HEDU Smart Watch 3.0", "price": 899 },
  { "name": "Cadnut Smart Band T800", "price": 599 },
  { "name": "VEhop Smart Watch V2", "price": 799 },

                

              ],
                
                  "Software Tools/AI Platforms/ integration Accessories": [
                   
                  { "name": "UiPath Robotic Process Automation", "price": 14999 },
  { "name": "Automation Anywhere Enterprise", "price": 13999 },
  { "name": "Blue Prism RPA Platform", "price": 12999 },
  { "name": "WorkFusion Intelligent Automation", "price": 11999 },
  { "name": "Kofax TotalAgility", "price": 10999 },
  { "name": "Pega Systems AI Workflow", "price": 9999 },
  { "name": "Appian Low-Code Automation", "price": 8999 },
  { "name": "NICE CXone AI Contact Center", "price": 7999 },
  { "name": "IBM RPA Studio", "price": 7499 },
  { "name": "Microsoft Power Automate", "price": 6999 },
  { "name": "Zapier Workflow Automation", "price": 5999 },
  { "name": "Celonis Process Mining", "price": 6499 },
  { "name": "Hyperscience Document AI", "price": 6999 },
  { "name": "Salesforce Einstein AI", "price": 9999 },
  { "name": "HubSpot AI CRM Tools", "price": 7999 },
  { "name": "Hootsuite Insights AI", "price": 4999 },
  { "name": "Cognizant Intelligent Automation", "price": 8999 },
  { "name": "ServiceNow AI Ops", "price": 9999 },
  { "name": "Sage AI Accounting Tools", "price": 5999 },
  { "name": "Grammarly Business AI", "price": 2999 },
  { "name": "Drift Conversational AI", "price": 4999 },
  { "name": "ChatGPT API (OpenAI)", "price": 1999 },
  { "name": "AWS AI Services", "price": 9999 },
  { "name": "Adobe Sensei AI", "price": 8999 },
  { "name": "Tableau AI Analytics", "price": 7999 },
  { "name": "Alteryx AI Data Prep", "price": 6999 },
  { "name": "DataRobot AutoML", "price": 9999 },
  { "name": "Splunk AI Monitoring", "price": 8499 },
  { "name": "TensorFlow ML Framework", "price": 0 },
  { "name": "H2O.ai ML Studio", "price": 4999 },
  { "name": "ThoughtSpot AI BI", "price": 7999 },
  { "name": "Anaplan AI Planning", "price": 8999 },
  { "name": "Zoho AI CRM Suite", "price": 5999 },
  { "name": "X.ai Scheduling Assistant", "price": 2999 },
  { "name": "Algolia AI Search", "price": 4999 },
  { "name": "C3 AI Predictive Suite", "price": 10999 },
  { "name": "Inbenta AI Chatbot", "price": 3999 },
  { "name": "DeepL AI Translator", "price": 1999 },
  { "name": "Gong.io AI Sales Insights", "price": 7999 },
  { "name": "Brevo AI Email Automation", "price": 3499 },
  { "name": "OneTrust AI Privacy Tools", "price": 6999 },
  { "name": "Amelia Conversational AI", "price": 9999 },
  { "name": "Persado AI Marketing", "price": 8999 },
  { "name": "Sift AI Fraud Detection", "price": 7999 },
  { "name": "Moveworks AI IT Support", "price": 6499 },
  { "name": "SymphonyAI Enterprise Suite", "price": 9999 },
  { "name": "PathAI Medical Diagnostics", "price": 11999 },
  { "name": "Teneo AI Virtual Assistant", "price": 6999 },
  { "name": "Clara Labs AI Scheduler", "price": 2999 },




  { "name": "Notion AI", "price": 3999 },
  { "name": "Gamma AI Presentations", "price": 2999 },
  { "name": "Tome AI Storytelling", "price": 2499 },
  { "name": "Supernormal Meeting Notes", "price": 1999 },
  { "name": "Fathom AI Meeting Assistant", "price": 1499 },
  { "name": "Fireflies.ai Transcription", "price": 2999 },
  { "name": "Nyota AI Notetaker", "price": 1999 },
  { "name": "Consensus AI Research Summaries", "price": 2499 },
  { "name": "Elicit AI Research Assistant", "price": 1999 },
  { "name": "Mem AI Notes", "price": 2999 },
  { "name": "Kipwise Knowledge Management", "price": 2499 },
  { "name": "Guru AI Wiki Assistant", "price": 2999 },
  { "name": "Slite AI Docs", "price": 1999 },
  { "name": "Teal Resume Builder", "price": 1499 },
  { "name": "Enhancv AI Resume", "price": 1999 },
  { "name": "Kickresume AI Resume", "price": 1799 },
  { "name": "Resume.io AI Templates", "price": 1499 },
  { "name": "Lavender AI Sales Email Assistant", "price": 2499 },
  { "name": "Apollo AI Sales Platform", "price": 2999 },
  { "name": "Clay AI Prospecting", "price": 3499 },
  { "name": "Warmly AI Sales Intelligence", "price": 1999 },
  { "name": "Markopolo AI Ad Automation", "price": 2999 },
  { "name": "AdCreative AI Ad Generator", "price": 2499 },
  { "name": "Copy.ai for Ads", "price": 1999 },
  { "name": "Jasper Ads Suite", "price": 3499 },
  { "name": "Writesonic Ad Writer", "price": 1499 },
  { "name": "Ocoya AI Social Scheduler", "price": 2999 },
  { "name": "FeedHive AI Social Manager", "price": 2499 },
  { "name": "Vista Social AI Tools", "price": 1999 },
  { "name": "Predis.ai Social Content", "price": 1499 },
  { "name": "Decktopus AI Presentation Builder", "price": 2499 },
  { "name": "Presentations.ai Slide Designer", "price": 2999 },
  { "name": "Motion AI Task Planner", "price": 3499 },
  { "name": "ClickUp AI Productivity Suite", "price": 2999 },
  { "name": "Asana AI Task Manager", "price": 2499 },
  { "name": "Trello AI Boards", "price": 1999 },
  { "name": "Reclaim AI Scheduler", "price": 1499 },
  { "name": "Clockwise AI Calendar", "price": 1999 },
  { "name": "Magical AI Scheduling", "price": 2499 },
  { "name": "SaneBox AI Email Organizer", "price": 1499 },
  { "name": "Shortwave AI Inbox", "price": 1999 },
  { "name": "MailMaestro AI Email Writer", "price": 2499 },
  { "name": "HubSpot AI Email Tools", "price": 2999 },
  { "name": "Tidio AI Chatbot", "price": 1999 },
  { "name": "Intercom AI Support", "price": 2999 },
  { "name": "Ada AI Customer Service", "price": 2499 },
  { "name": "Hiver AI Helpdesk", "price": 1999 },
  { "name": "Textio AI Job Descriptions", "price": 1499 },
  { "name": "CVViZ AI Resume Screening", "price": 1999 },
  { "name": "Paradox AI Recruiting", "price": 2999 },
  { "name": "HireVue AI Interviews", "price": 3499 },



  { "name": "LangChain AI Framework", "price": 1200 },
  { "name": "LangGraph Workflow Engine", "price": 1440 },
  { "name": "AG2 AutoGen Agents", "price":1990 },
  { "name": "CrewAI Multi-Agent Framework", "price": 1000 },
  { "name": "Phoenix AI Debugging Suite", "price":1220 },
  { "name": "Amazon SageMaker Studio", "price": 9999 },
  { "name": "Google Vertex AI", "price": 8999 },
  { "name": "Microsoft Azure AI Studio", "price": 8499 },
  { "name": "IBM Watsonx.ai", "price": 7999 },
  { "name": "Anthropic Claude API", "price": 1999 },
  { "name": "Perplexity AI Pro", "price": 1499 },
  { "name": "Inflection Pi Companion", "price": 999 },
  { "name": "Gamma AI Deck Builder", "price": 2999 },
  { "name": "Tome AI Presentation Tool", "price": 2499 },
  { "name": "Supernormal Meeting Summaries", "price": 1999 },
  { "name": "Fathom AI Call Recorder", "price": 1499 },
  { "name": "Mem AI Workspace", "price": 2999 },
  { "name": "Reflect AI Notes", "price": 2499 },
  { "name": "Reclaim AI Calendar Assistant", "price": 1999 },
  { "name": "Motion AI Scheduler", "price": 3499 },
  { "name": "ClickUp AI Productivity Suite", "price": 2999 },
  { "name": "Asana AI Task Manager", "price": 2499 },
  { "name": "Trello AI Boards", "price": 1999 },
  { "name": "Shortwave AI Inbox", "price": 1999 },
  { "name": "SaneBox AI Email Organizer", "price": 1499 },
  { "name": "Magical AI Scheduling", "price": 2499 },
  { "name": "Clockwise AI Calendar", "price": 1999 },
  { "name": "Lavender AI Email Assistant", "price": 2499 },
  { "name": "Apollo AI Sales Platform", "price": 2999 },
  { "name": "Clay AI Prospecting", "price": 3499 },
  { "name": "Warmly AI Sales Intelligence", "price": 1999 },
  { "name": "Markopolo AI Ad Automation", "price": 2999 },
  { "name": "AdCreative AI Generator", "price": 2499 },
  { "name": "Copy.ai Ad Writer", "price": 1999 },
  { "name": "Jasper Ads Suite", "price": 3499 },
  { "name": "Writesonic Ad Writer", "price": 1499 },
  { "name": "Ocoya AI Social Scheduler", "price": 2999 },
  { "name": "FeedHive AI Social Manager", "price": 2499 },
  { "name": "Vista Social AI Tools", "price": 1999 },
  { "name": "Predis.ai Social Content", "price": 1499 },
  { "name": "Decktopus AI Slide Builder", "price": 2499 },
  { "name": "Presentations.ai Designer", "price": 2999 },
  { "name": "Teal AI Resume Builder", "price": 1499 },
  { "name": "Enhancv AI Resume Editor", "price": 1999 },
  { "name": "Kickresume AI Templates", "price": 1799 },
  { "name": "Resume.io AI Generator", "price": 1499 },
  { "name": "Textio AI Job Descriptions", "price": 1499 },
  { "name": "CVViZ AI Resume Screening", "price": 1999 },


  
  { "name": "Bitdefender Antivirus Plus", "price": 2999 },
  { "name": "Norton Antivirus Plus", "price": 2999 },
  { "name": "McAfee AntiVirus", "price": 3499 },
  { "name": "Malwarebytes Premium", "price": 3749 },
  { "name": "Sophos Home Premium", "price": 2499 },
  { "name": "Avira Antivirus Pro", "price": 3499 },
  { "name": "AVG Internet Security", "price": 4999 },
  { "name": "Kaspersky Standard", "price": 3999 },
  { "name": "Trend Micro Antivirus+", "price": 1995 },
  { "name": "ESET NOD32 Antivirus", "price": 5999 },
  { "name": "F-Secure SAFE", "price": 6999 },
  { "name": "G DATA Antivirus", "price": 3995 },
  { "name": "Webroot SecureAnywhere", "price": 2999 },
  { "name": "TotalAV Antivirus Pro", "price": 1900 },
  { "name": "Intego Mac Internet Security", "price": 4999 },
  { "name": "ZoneAlarm Pro Firewall", "price": 4000 },
  { "name": "Panda Dome Essential", "price": 2999 },
  { "name": "BullGuard Antivirus", "price": 3499 },
  { "name": "Comodo Antivirus", "price": 2499 },
  { "name": "Quick Heal Total Security", "price": 2999 },
  { "name": "NPAV Antivirus", "price": 999 },
  { "name": "Microsoft Defender", "price": 990 },
  { "name": "Immunet Antivirus", "price": 890 },
  { "name": "ClamAV", "price": 990 },
  { "name": "IObit Malware Fighter", "price": 2000 },
  { "name": "Surfshark Antivirus", "price": 1795 },
  { "name": "Guardio Antivirus", "price": 3120 },
  { "name": "Adaware Antivirus Pro", "price": 2999 },
  { "name": "Dr.Web Security Space", "price": 3999 },
  { "name": "VIRUSfighter Pro", "price": 2499 },
  { "name": "PC Matic", "price": 2999 },
  { "name": "Fortinet FortiClient", "price": 4999 },
  { "name": "AhnLab V3 Internet Security", "price": 3999 },
  { "name": "eScan Antivirus", "price": 3499 },
  { "name": "Zemana Antivirus", "price": 2999 },
  { "name": "HitmanPro", "price": 2499 },
  { "name": "NANO Antivirus", "price": 1200 },
  { "name": "Vipre Antivirus Plus", "price": 2999 },
  { "name": "SecureAPlus", "price": 0 },
  { "name": "Avast Premium Security", "price": 5028 },
  { "name": "360 Total Security", "price": 1670 },
  { "name": "Trellix Endpoint Security", "price": 5999 },
  { "name": "Cylance Smart Antivirus", "price": 3999 },
  { "name": "Ashampoo Antivirus", "price": 2999 },
  { "name": "Reimage Repair", "price": 2499 },
  { "name": "Spybot Search & Destroy", "price": 1890 },
  { "name": "SUPERAntiSpyware Pro", "price": 2999 },
  { "name": "Rising Antivirus", "price": 0 },
  { "name": "Max Secure Antivirus", "price": 3499 },
  { "name": "Tachyon Internet Security", "price": 3999 },




   ],
          

                      "Cameras and Webcam": [
                    
  { "name": "Sony Alpha ZV-E10L Mirrorless Camera", "price": 61490 },
  { "name": "VJIANGER 4K Vlogging Camera", "price": 7999 },
  { "name": "Panasonic LUMIX G7 Mirrorless Camera", "price": 42450 },
  { "name": "Sony Alpha ILCE-6700 Body Only", "price": 113489 },
  { "name": "Focusify 4K Digital Camera (Pink)", "price": 5625 },
  { "name": "Saneen 64MP Vlogging Camera", "price": 11799 },
  { "name": "Kodak PIXPRO FZ45-WH", "price": 15365 },
  { "name": "Canon EOS R10 Mirrorless Camera", "price": 97999 },
  { "name": "GoPro HERO12 Action Camera", "price": 26990 },
  { "name": "Sony Alpha ILCE-7M3K Full Frame", "price": 141490 },
  { "name": "Fujifilm X-M5 Mirrorless Camera", "price": 88000 },
  { "name": "Sony Alpha ILCE-6400M with Zoom Lens", "price": 88489 },
  { "name": "Sony Alpha ZV-E10M2K Vlog Camera", "price": 84489 },
  { "name": "Sony Alpha ILCE-6100X Mirrorless Camera", "price": 73990 },
  { "name": "Sony Alpha ILCE-6700L with Lens", "price": 122989 },
  { "name": "Digital Camera 44MP Compact (Pink)", "price": 4499 },
  { "name": "LEKATO 4K 48MP Camera for Kids", "price": 3899 },
  { "name": "VAHOIALD 44MP Digital Camera", "price": 3899 },
  { "name": "Focusify 56MP Autofocus Camera", "price": 3999 },
  { "name": "Lecran 1080p Kids Camera", "price": 4299 },
  { "name": "Digital Camera 56MP Compact (Silver)", "price": 4799 },
  { "name": "4K Digital Camera (Pink)", "price": 4699 },
  { "name": "CADDLE & Toys Instant Print Camera (Purple)", "price": 2812 },
  { "name": "CADDLE & TOES Instant Print Camera (Blue)", "price": 2715 },
  { "name": "Mini Digital Camera with Keychain", "price": 2999 },
  { "name": "Cason Mini Camera Printer (Panda)", "price": 3199 },
  { "name": "Digital Camera FHD 4K 44MP (Cream)", "price": 4999 },
  { "name": "Digital Camera 56MP Anti-Shake (Black)", "price": 4499 },
  { "name": "LEO LIFE STYLE Instant Print Camera (Blue)", "price": 1499 },
  { "name": "Instant Print Camera for Kids (Purple)", "price": 2299 },
  { "name": "Memories Insite Instant Print Camera (Blue)", "price": 2299 },
  { "name": "Logitech HD Webcam C270", "price": 1995 },
  { "name": "ZEBRONICS Crystal Clear Webcam", "price": 549 },
  { "name": "chora HD Webcam with Mic", "price": 880 },
  { "name": "ZEBRONICS ZEB-CRISP PRO Webcam", "price": 1199 },
  { "name": "Logitech MX Brio 4K Webcam", "price": 16995 },
  { "name": "BigPassport Pro-Live_N3 Webcam", "price": 1054 },
  { "name": "Quantron QPC-1010 Webcam", "price": 809 },
  { "name": "ASTRUM WM100 Professional Webcam", "price": 1499 },
  { "name": "Kreo Owl 1080p Webcam", "price": 3499 },
  { "name": "ULTRABYTES 720P HD Webcam", "price": 972 },
  { "name": "ZEBRONICS Ultimate Pro 2 Webcam", "price": 1399 },
  { "name": "LG VC23GA HD Webcam", "price": 1499 },
  { "name": "RAPOO C200 Webcam", "price": 1799 },
  { "name": "Logitech Brio 500 Webcam", "price": 9999 },
  { "name": "Lenovo 300 FHD Webcam", "price": 2943 },
  { "name": "HP 320 Webcam", "price": 2299 },
  { "name": "ZEBRONICS Zeb Pure Plus 4K Webcam", "price": 2199 },
  { "name": "ASTRUM WM720 Full HD Webcam", "price": 1396 },

  
  { "name": "Canon EOS R6 Mark II", "price": 343995 },
  { "name": "Sony Alpha a9 III", "price": 529990 },
  { "name": "Panasonic LUMIX S9", "price": 149990 },
  { "name": "Nikon Z6 III", "price": 247990 },
  { "name": "Sony Alpha 7CR", "price": 293990 },
  { "name": "Sony Alpha 7C II", "price": 214990 },
  { "name": "Fujifilm GFX 100 II", "price": 799999 },
  { "name": "Canon EOS R1", "price": 630995 },
  { "name": "Canon EOS R5 Mark II", "price": 405995 },
  { "name": "Sony ZV-E1", "price": 214990 },
  { "name": "Fujifilm X-S20", "price": 110669 },
  { "name": "Canon EOS R8", "price": 116000 },
  { "name": "Nikon Z8", "price": 343995 },
  { "name": "Canon EOS R100", "price": 39690 },
  { "name": "Sony ZV-1 II", "price": 86990 },
  { "name": "Sony ZV-1F", "price": 50690 },
  { "name": "Canon PowerShot V10", "price": 39995 },
  { "name": "GoPro Hero 13 Black", "price": 44990 },
  { "name": "GoPro Hero 11 Black Mini", "price": 41500 },
  { "name": "GoPro Hero 10 Black Bones", "price": 54500 },
  { "name": "DJI Action 2", "price": 40990 },
  { "name": "Canon EOS R5 C", "price": 339995 },
  { "name": "Canon EOS R6", "price": 215995 },
  { "name": "Canon EOS R5", "price": 339995 },
  { "name": "Fujifilm Instax Mini 11", "price": 6499 },
  { "name": "Fujifilm X Pro3", "price": 88000 },
  { "name": "Fujifilm X-T30", "price": 78990 },
  { "name": "Sony ZV-1", "price": 52989 },
  { "name": "Sony RX10 IV", "price": 131250 },
  { "name": "Canon PowerShot SX620HS", "price": 14173 },
  { "name": "Canon PowerShot SX60HS", "price": 49210 },
  { "name": "Nikon CoolPix P610", "price": 90811 },
  { "name": "Nikon CoolPix P600", "price": 90988 },
  { "name": "Sony DSC WX500", "price": 99999 },
  { "name": "Sony DSC W690", "price": 10990 },
  { "name": "Sony DSC S650", "price": 26086 },
  { "name": "Canon PowerShot SX400IS", "price": 77580 },
  { "name": "Sony DSC HX10VR", "price": 17990 },
  { "name": "Sony Alpha NEX-C3", "price": 91215 },
  { "name": "Sony Alpha a7", "price": 100138 },
  { "name": "Sony Alpha a6500", "price": 109990 },
  { "name": "Sony Alpha a6300", "price": 79500 },
  { "name": "Sony Alpha a6000", "price": 61490 },
  { "name": "Sony Alpha a5100", "price": 44328 },
  { "name": "Sony Alpha a5000", "price": 99464 },
  { "name": "Sony A68", "price": 89440 },
  { "name": "Samsung WB35F", "price": 38606 },
  { "name": "Samsung WB30F", "price": 43645 },
  { "name": "Samsung ST150F", "price": 69947 },
  { "name": "Samsung NX500", "price": 84990 },
           

  { "name": "Canon PowerShot G7 X Mark III", "price": 69995 },
  { "name": "Canon PowerShot SX740 HS", "price": 42995 },
  { "name": "Canon PowerShot SX70 HS", "price": 61995 },
  { "name": "Canon IXUS 285 HS", "price": 27995 },
  { "name": "Canon PowerShot G7 X Mark II", "price": 61995 },
  { "name": "Canon PowerShot V10", "price": 39995 },
  { "name": "Sony Cybershot DSC-HX9V", "price": 13999 },
  { "name": "Samsung ES91 Point & Shoot Camera", "price": 4250 },
  { "name": "FitSpark Dolphin 20MP Action Camera", "price": 12999 },
  { "name": "Insta360 X5 Action Camera", "price": 54990 },
  { "name": "Canon PowerShot V1", "price": 77999 },
  { "name": "Sony FX2 Cinema Line Camera", "price": 399999 },
  { "name": "Sony BURANO 8K Motion Picture Camera", "price": 3769990 },
  { "name": "ApnaCam Mini PTZ Security Camera", "price": 1695 },
  { "name": "ApnaCam Smart Mini Robot Camera", "price": 1904 },
  { "name": "PERAMISYM Spy Button Camera", "price": 709 },
  { "name": "PERAMISYM HD Mini IP Camera", "price": 1050 },
  { "name": "Prime Assure 48MP Mini Camera", "price": 1899 },
  { "name": "Hokti Kids Mini Camera", "price": 609 },
  { "name": "Hokti Mini Digital Camera", "price": 623 },
  { "name": "Hokti Kids Digital Camera T13", "price": 630 },
  { "name": "CADDLE & Toys Kids Camera (Pink)", "price": 2812 },
  { "name": "CADDLE & Toys Kids Camera (Purple)", "price": 2715 },
  { "name": "Cason Mini Camera Printer (Unicorn)", "price": 3199 },
  { "name": "LEO LIFE STYLE Instant Print Camera (Blue)", "price": 1499 },
  { "name": "Instant Print Camera for Kids (Purple)", "price": 2299 },
  { "name": "Memories Insite Instant Camera (Blue)", "price": 2299 },
  { "name": "Mini Digital Camera with Keychain", "price": 2999 },
  { "name": "Digital Camera 44MP (Light Green)", "price": 4299 },
  { "name": "Digital Camera 44MP (Pink)", "price": 4499 },
  { "name": "Digital Camera 56MP (Silver)", "price": 4799 },
  { "name": "Digital Camera 56MP (Black)", "price": 4499 },
  { "name": "Digital Camera 56MP (Cream)", "price": 4999 },
  { "name": "Digital Camera 56MP (Blue)", "price": 4999 },
  { "name": "Digital Camera 56MP (Red)", "price": 4999 },
  { "name": "Digital Camera 56MP (Green)", "price": 4999 },
  { "name": "Digital Camera 56MP (Yellow)", "price": 4999 },
  { "name": "Digital Camera 56MP (White)", "price": 4999 },
  { "name": "Digital Camera 56MP (Orange)", "price": 4999 },
  { "name": "Digital Camera 56MP (Purple)", "price": 4999 },
  { "name": "Digital Camera 56MP (Gray)", "price": 4999 },
  { "name": "Digital Camera 56MP (Gold)", "price": 4999 },
  { "name": "Digital Camera 56MP (Rose)", "price": 4999 },
  { "name": "Digital Camera 56MP (Sky Blue)", "price": 4999 },
  { "name": "Digital Camera 56MP (Mint)", "price": 4999 },
  { "name": "Digital Camera 56MP (Coral)", "price": 4999 },
  { "name": "Digital Camera 56MP (Lavender)", "price": 4999 },
  { "name": "Digital Camera 56MP (Teal)", "price": 4999 },
  { "name": "Digital Camera 56MP (Charcoal)", "price": 4999 },
  { "name": "Digital Camera 56MP (Navy)", "price": 4999 },

  { "name": "Leica M11 Monochrom", "price": 799000 },
  { "name": "Leica Q3", "price": 599000 },
  { "name": "Leica SL2-S", "price": 499000 },
  { "name": "DJI Osmo Pocket 3", "price": 51990 },
  { "name": "DJI Osmo Action 4", "price": 38990 },
  { "name": "DJI Pocket 2 Creator Combo", "price": 34990 },
  { "name": "DJI Mini 4 Pro Drone Camera", "price": 98990 },
  { "name": "DJI Air 3 Drone Camera", "price": 124990 },
  { "name": "DJI Mavic 3 Pro Drone", "price": 189990 },
  { "name": "Insta360 X3", "price": 47990 },
  { "name": "Insta360 Go 3", "price": 34990 },
  { "name": "Insta360 One RS", "price": 42990 },
  { "name": "Insta360 Ace Pro", "price": 54990 },
  { "name": "Olympus Tough TG-6", "price": 38990 },
  { "name": "Olympus OM-D E-M10 Mark IV", "price": 69990 },
  { "name": "Olympus PEN E-PL10", "price": 49990 },
  { "name": "Kodak PixPro AZ528", "price": 18990 },
  { "name": "Kodak PixPro FZ55", "price": 9990 },
  { "name": "Kodak Printomatic Instant Camera", "price": 6999 },
  { "name": "Kodak Mini Shot 3 Retro", "price": 8499 },
  { "name": "Kodak FunSaver 35mm Disposable", "price": 999 },
  { "name": "Polaroid Now+ Instant Camera", "price": 12999 },
  { "name": "Polaroid Go Instant Camera", "price": 8499 },
  { "name": "Polaroid I-Type Camera", "price": 10999 },
  { "name": "Fujifilm Instax Mini Evo", "price": 18999 },
  { "name": "Fujifilm Instax Square SQ1", "price": 10499 },
  { "name": "Fujifilm Instax Wide 300", "price": 11999 },
  { "name": "Fujifilm Instax Mini LiPlay", "price": 13499 },
  { "name": "Canon Ivy CLIQ+2", "price": 9999 },
  { "name": "Canon Ivy CLIQ2", "price": 7999 },
  { "name": "Canon Zoemini S2", "price": 10999 },
  { "name": "Canon Zoemini C", "price": 8499 },
  { "name": "Nikon D7500 DSLR", "price": 84990 },
  { "name": "Nikon D5600 DSLR", "price": 62990 },
  { "name": "Nikon D3500 DSLR", "price": 42990 },
  { "name": "Nikon Z50 Mirrorless", "price": 77995 },
  { "name": "Nikon Z30 Mirrorless", "price": 59990 },
  { "name": "Nikon Z fc Mirrorless", "price": 78990 },
  { "name": "Canon EOS 90D DSLR", "price": 89990 },
  { "name": "Canon EOS 1500D DSLR", "price": 42990 },
  { "name": "Canon EOS 200D II DSLR", "price": 58990 },
  { "name": "Canon EOS 3000D DSLR", "price": 34990 },
  { "name": "Canon EOS RP Mirrorless", "price": 99990 },
  { "name": "Canon EOS M50 Mark II", "price": 58990 },
  { "name": "Sony Alpha A7 IV", "price": 214990 },
  { "name": "Sony Alpha A7R V", "price": 309990 },
  { "name": "Sony Alpha A1", "price": 549990 },
  { "name": "Sony FX3 Cinema Line", "price": 349990 },
  { "name": "Sony FX30 Cinema Line", "price": 189990 },


                  ],
                   "Drones": [
  
                    
  { "name": "DJI Agras T40", "price": 899000 },
  { "name": "DJI Agras T30", "price": 799000 },
  { "name": "DJI Agras T20P", "price": 749000 },
  { "name": "DJI Agras T10", "price": 699000 },
  { "name": "DJI Agras MG-1P", "price": 659000 },
  { "name": "DJI Phantom 4 RTK", "price": 499000 },
  { "name": "DJI Matrice 600 Pro", "price": 599000 },
  { "name": "DJI Matrice 200 V2", "price": 549000 },
  { "name": "DJI Matrice 210 RTK V2", "price": 579000 },
  { "name": "DJI Matrice 100", "price": 399000 },
  { "name": "DJI Phantom 3 Professional", "price": 29900 },
  { "name": "DJI Phantom 3 Standard", "price": 24900 },
  { "name": "DJI Phantom 3 Advanced", "price": 27900 },
  { "name": "DJI Phantom 2 Vision+", "price": 19900 },
  { "name": "DJI Phantom 2", "price": 17900 },
  { "name": "DJI Flame Wheel F450", "price": 14900 },
  { "name": "DJI S900 Hexacopter", "price": 49900 },
  { "name": "DJI S1000 Octocopter", "price": 89900 },
  { "name": "DJI RoboMaster TT", "price": 12900 },
  { "name": "DJI RoboMaster S1", "price": 39900 },
  { "name": "Autel Robotics Dragonfish Lite", "price": 899000 },
  { "name": "Autel Robotics Dragonfish Pro", "price": 1299000 },
  { "name": "Autel Robotics Dragonfish Standard", "price": 1099000 },
  { "name": "Autel Robotics Kestrel", "price": 999000 },
  { "name": "Skydio Dock Lite", "price": 499000 },
  { "name": "Skydio Dock", "price": 899000 },
  { "name": "Skydio Scout", "price": 999000 },
  { "name": "Skydio X10", "price": 1299000 },
  { "name": "Parrot Disco FPV", "price": 49900 },
  { "name": "Parrot Bluegrass Fields", "price": 89900 },
  { "name": "Parrot Sequoia+", "price": 99900 },
  { "name": "Yuneec H520E", "price": 99900 },
  { "name": "Yuneec Tornado H920", "price": 129900 },
  { "name": "Yuneec Breeze 4K", "price": 19900 },
  { "name": "Yuneec Q500 4K", "price": 29900 },
  { "name": "Yuneec Typhoon G", "price": 24900 },
  { "name": "Holy Stone HS710", "price": 22900 },
  { "name": "Holy Stone HS430", "price": 11900 },
  { "name": "Holy Stone HS260", "price": 9900 },
  { "name": "Holy Stone HS210", "price": 6900 },
  { "name": "Holy Stone HS190", "price": 5900 },
  { "name": "Potensic P5", "price": 8900 },
  { "name": "Potensic A20", "price": 4900 },
  { "name": "Potensic U47", "price": 7900 },
  { "name": "Potensic U36W", "price": 6900 },
  { "name": "Potensic T35", "price": 18900 },
  { "name": "Ruko F11GIM2", "price": 39900 },
  { "name": "Ruko F11MINI", "price": 28900 },
  { "name": "Ruko U11PRO", "price": 34900 },
  { "name": "Ruko U11S", "price": 31900 },
  { "name": "Fimi Palm 2 Pro", "price": 18900 },
  { "name": "Fimi X8 SE 2020", "price": 59900 },
  { "name": "Fimi X8 SE 2019", "price": 54900 },
  { "name": "Fimi X8 Mini SE", "price": 49900 },
  { "name": "Veeniix V10", "price": 39900 },
  { "name": "Veeniix V9", "price": 34900 },
  { "name": "Veeniix V8", "price": 29900 },
  { "name": "Snaptain A15H", "price": 9900 },
  { "name": "Snaptain H823H", "price": 5900 },
  { "name": "Snaptain SP300", "price": 7900 },
  { "name": "JJRC H36", "price": 4900 },
  { "name": "JJRC H37 Elfie", "price": 5900 },
  { "name": "JJRC X5", "price": 18900 },
  { "name": "JJRC X12", "price": 24900 },
  { "name": "Walkera Voyager 4", "price": 199900 },
  { "name": "Walkera AiBao", "price": 49900 },
  { "name": "Walkera Furious 215", "price": 29900 },
  { "name": "Walkera Rodeo 110", "price": 19900 },
  { "name": "PowerVision PowerDolphin", "price": 99900 },
  { "name": "PowerVision PowerSeeker", "price": 49900 },
  { "name": "PowerVision PowerEgg X Wizard", "price": 109900 },
  { "name": "PowerVision PowerEgg X Explorer", "price": 89900 },
  { "name": "Airbots AeroX Pro", "price": 69900 },
  { "name": "Dhaksha Hexacopter", "price": 99900 },
  { "name": "Garuda Surveyor Drone", "price": 89900 },
  { "name": "General Aeronautics GA-VTOL", "price": 99900 },
  { "name": "Hubblefly HF-Thermal", "price": 79900 },
  { "name": "ideaForge SWITCH UAV", "price": 999000 },
  { "name": "IoTechWorld Survey Drone", "price": 84900 },
  { "name": "IZI Drone Mini", "price": 39900 },
  { "name": "Magicmyna SkyCam Pro", "price": 59900 },
  { "name": "Marut Drones SeedBot", "price": 89900 },
  { "name": "Paras Aerospace AgriScout", "price": 79900 },
  { "name": "Scandron Surveyor", "price": 99900 },
  { "name": "Thanos Drone Z", "price": 109900 },
  { "name": "DJI Mini 2 SE", "price": 49900 },
  { "name": "DJI Mini 3", "price": 69900 },
  { "name": "DJI Mini 3 Fly More Combo", "price": 89900 },
  { "name": "DJI Mini 4 Pro Fly More Combo", "price": 109900 },
  { "name": "DJI Mavic 3 Fly More Combo", "price": 209900 },
  { "name": "DJI Mavic 3 Cine Premium Combo", "price": 349900 },
  { "name": "DJI Mavic 2 Enterprise Advanced", "price": 299900 },
  { "name": "DJI Mavic 2 Enterprise Dual", "price": 249900 },
  { "name": "DJI Mavic 2 Enterprise Zoom", "price": 229900 },
  { "name": "DJI Mavic 2 Fly More Kit", "price": 29900 },
  { "name": "DJI Mavic Air Fly More Combo", "price": 99900 },
                    
                  
  { "name": "DJI Mavic 3 Pro", "price": 189990 },
  { "name": "DJI Mini 4 Pro", "price": 98990 },
  { "name": "DJI Air 3", "price": 124990 },
  { "name": "DJI Avata 2", "price": 57600 },
  { "name": "DJI Phantom 4 Pro V2.0", "price": 444800 },
  { "name": "DJI Inspire 2", "price": 299000 },
  { "name": "DJI Matrice 300 RTK", "price": 599000 },
  { "name": "DJI Mini 3 Pro", "price": 95800 },
  { "name": "DJI Mavic Air 2", "price": 77100 },
  { "name": "DJI Spark", "price": 51300 },
  { "name": "Autel Evo II Pro", "price": 129990 },
  { "name": "Autel Evo Nano Plus", "price": 118300 },
  { "name": "Autel Evo Lite Plus", "price": 163500 },
  { "name": "Autel Evo Max 4T", "price": 189990 },
  { "name": "Autel Evo II Dual 640T", "price": 229990 },
  { "name": "Skydio 2+", "price": 99900 },
  { "name": "Skydio X2", "price": 299000 },
  { "name": "Skydio R1", "price": 149000 },
  { "name": "Parrot Anafi Ai", "price": 642700 },
  { "name": "Parrot Bebop 2", "price": 29900 },
  { "name": "Parrot Mambo FPV", "price": 14900 },
  { "name": "Yuneec Typhoon H3", "price": 129900 },
  { "name": "Yuneec Mantis Q", "price": 49900 },
  { "name": "Holy Stone HS720E", "price": 39700 },
  { "name": "Holy Stone HS100", "price": 29200 },
  { "name": "Holy Stone HS700D", "price": 37800 },
  { "name": "Holy Stone HS175D", "price": 24700 },
  { "name": "Holy Stone HS510", "price": 43600 },
  { "name": "Holy Stone HS360S", "price": 26800 },
  { "name": "Holy Stone HS110G", "price": 20400 },
  { "name": "Holy Stone HS165", "price": 15000 },
  { "name": "Holy Stone HS240", "price": 12000 },
  { "name": "Holy Stone HS120D", "price": 16000 },
  { "name": "Holy Stone HS700E", "price": 37800 },
  { "name": "Potensic Atom SE", "price": 34400 },
  { "name": "Potensic Dreamer Pro", "price": 46700 },
  { "name": "Potensic T25", "price": 15000 },
  { "name": "Potensic T18", "price": 10000 },
  { "name": "Potensic D80", "price": 20000 },
  { "name": "Potensic Atom 2", "price": 53200 },
  { "name": "Potensic Atom Mini", "price": 49100 },
  { "name": "Ruko F11Pro 2", "price": 35000 },
  { "name": "Ruko U11MINI 4K", "price": 32000 },
  { "name": "HoverAir X1 Pro", "price": 64100 },
  { "name": "HoverAir X1 Pro Max", "price": 101100 },
  { "name": "HoverAir X1", "price": 32100 },
  { "name": "Fimi X8 SE 2022 V2", "price": 68400 },
  { "name": "Fimi X8 Mini V2", "price": 52500 },
  { "name": "Fimi X8 Tele Pro", "price": 69900 },
  { "name": "Fimi X8 Pro", "price": 59900 },
  { "name": "Fimi A3", "price": 25000 },
  { "name": "Fimi Mini 3", "price": 52500 },
  { "name": "Veeniix V11PRO", "price": 54900 },
  { "name": "Snaptain SP500", "price": 15000 },
  { "name": "Snaptain SP650", "price": 12000 },
  { "name": "Snaptain SP7100", "price": 18900 },
  { "name": "JJRC X11", "price": 22900 },
  { "name": "JJRC H68", "price": 9900 },
  { "name": "Walkera Vitus", "price": 89900 },
  { "name": "Walkera Tali H500", "price": 129900 },
  { "name": "Ehang 184", "price": 899000 },
  { "name": "Freefly Alta X", "price": 899000 },
  { "name": "Flyability Elios 2", "price": 499000 },
  { "name": "Insitu ScanEagle", "price": 999000 },
  { "name": "WingtraOne Gen II", "price": 899000 },
  { "name": "Airobotics Iron Drone", "price": 799000 },
  { "name": "JOUAV CW-25", "price": 699000 },
  { "name": "Draganflyer Guardian", "price": 599000 },
  { "name": "Brinc Lemur", "price": 499000 },
  { "name": "Guardian SC1", "price": 399000 },
  { "name": "PowerVision PowerEgg X", "price": 89900 },
  { "name": "PowerVision PowerRay", "price": 99900 },
  { "name": "Airbots AeroX", "price": 59900 },
  { "name": "Dhaksha Agribot", "price": 79900 },
  { "name": "Garuda Kisan Drone", "price": 99900 },
  { "name": "General Aeronautics GA-Drone", "price": 89900 },
  { "name": "Hubblefly HF-One", "price": 69900 },
  { "name": "ideaForge Q Series", "price": 99900 },
  { "name": "IoTechWorld Krishi Drone", "price": 84900 },
  { "name": "IZI Drone Pro", "price": 59900 },
  { "name": "Magicmyna SkyCam", "price": 49900 },
  { "name": "Marut Drones AgriBot", "price": 79900 },
  { "name": "Paras Aerospace Scout", "price": 69900 },
  { "name": "Scandron Mapper", "price": 89900 },
  { "name": "Thanos Drone X", "price": 99900 },
  { "name": "DJI Mini SE", "price": 48100 },
  { "name": "DJI Mavic Mini 2", "price": 69000 },
  { "name": "DJI Mavic Pro Platinum", "price": 233600 },
  { "name": "DJI Mavic 3 Classic", "price": 178000 },
  { "name": "DJI Mavic 3T", "price": 635400 },
  { "name": "DJI Mavic 3E", "price": 429100 },
  { "name": "DJI Matrice 4T", "price": 599000 },
  { "name": "DJI Matrice 4E", "price": 599000 },
  { "name": "DJI Flip", "price": 51300 },
  { "name": "DJI Neo", "price": 23300 },
  { "name": "DJI Phantom 3 SE", "price": 29900 },
  { "name": "DJI Phantom 4 Advanced", "price": 361900 },
  { "name": "DJI Mavic Air", "price": 85100 },
  { "name": "DJI Mavic 2 Zoom", "price": 156800 },
  { "name": "DJI Mavic 2 Pro", "price": 256900 },

                  ],

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Tech Retail Store</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Store/Shop Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default TechStore;
  


  

